const admin_local_en = {
  refundreason: "Refund reason",
  delete_role_confirm: "Are you sure you want to delete this role?",
  delete_user_confirm: "Are you sure you want to delete this user?",
  status_filter_placeholder: "Status",
  status_filter_all: "All",
  entries_total: "{count} total entries on this invoice",
  entries_linked: "{count} linked product codes at this supplier on this invoice",
  entries_ignored: "{count} ignored product codes at this supplier on this invoice",
  entries_new: "{count} new product codes at this supplier on this invoice",
  status_draft: "Draft",
  status_new: "New",
  status_linked: "Linked",
  status_ignored: "Ignored",
  status_none: "No status",
  kiosk_day_open_required: "Ordering is not possible until day open is completed on the cash register.",
  kiosk_day_needs_close_open: "The cash register day needs to be closed and opened again before ordering.",
  kiosk_cash_register_communication_unsuccessful: "Communication with the cash register unsuccessful, please contact the personnel.",
  cashier_day_already_opened: "The day is already opened.",
  cashier_day_not_open: "Day is not open.",
  cashier_not_enough_money_in_drawer: "There is not enough money in the cash drawer for this payout.",
  cashier_cash_flow_invalid_input: "Select a reason and enter an amount greater than 0.",
  cashier_cash_flow_print_failed: "The document was created, but it could not be printed.",
  cashier_day_close_failed: "Day close did not succeed. The day is still open.",
  cashier_day_close_requires_cash_register_report: "Day close report cannot be created until the cash register report is created.",
  cashier_day_closed: "The cash register is closed.",
  montax_not_enough_money_in_drawer: "The cash register drawer does not contain enough cash for this payment. Please contact the personnel.",
  cashier_day_open_reprint_receipt_question: "The day is already open. Do you want to download and reprint the day-open receipt?",
  cashier_day_close_reprint_receipt_question: "The day is already closed. Do you want to download and reprint the day-close receipt?",
  cashier_day_reprint_download_failed: "Failed to download the previous day receipt for reprint.",
  cashier_day_close_history_button: "Print old day closure",
  cashier_day_close_history_title: "Print old day closure",
  cashier_day_close_history_select: "Select the day (fiscal day number - date):",
  cashier_day_close_history_period: "Enter the period (at most 31 days):",
  cashier_day_close_history_from: "From:",
  cashier_fiscal_report_period: "Enter the period:",
  cashier_fiscal_report_period_invalid: "Invalid period. The start date must not be after the end date.",
  cashier_day_close_history_to: "To:",
  cashier_day_close_history_period_invalid: "Invalid period. The start date must not be after the end date, and the period can be at most 31 days.",
  cashier_day_close_history_empty: "No day closure report was found in the selected period.",
  menu_editor_texts: {
    options: "options",
    mandatoryOptions: "mandatory options",
    includedOptions: "included options",
    optionalAdditions: "optional additions",
    quantity: "quantity",
    min: "min",
    max: "max",
    type: "type",
    local: "local",
    takeaway: "takeaway",
    proportional: "proportional",
    enabled: "enabled",
    disabled: "disabled",
    selected: "selected",
    notSelected: "not selected",
    token: "token",
    categoryAddition: "category addition",
    menuitemAddition: "menuitem addition",
    addedTo: "was added to",
    removedFrom: "was removed from",
    updatedIn: "was updated in",
    noTokenChanges: "no token changes",
    changedFields: "Changed Fields",
    categoryChanges: "Category changes",
    tokenOption: "token option",
    typeLabel: "type",
    quantityLabel: "quantity",
    minLabel: "min",
    maxLabel: "max",
    categoryTypeMultiple: "multiple",
    categoryTypeSeparate: "separate",
    categoryTypeMaxOne: "max one",
    categoryTypeOne: "exactly one",
    meal: "meal",
    drink: "drink",
    mealCategory: "meal category",
    drinkCategory: "drink category"
  },
  _active: "Act.",
  _add_category: "New cat.",
  _add_item: "New item",
  _available: "A",
  upsell_items: "Upsell items",
  _available_quantity: "Quantities",
  _brutto_price: "Brutto price",
  _brutto_unit_price: "B. u. price",
  _category: "Cat.",
  _default_production_line: "Prod. line",
  _default_takeaway_vat_category: "Taway. VAT",
  _default_vat_category: "VAT",
  _deleted: "Del.",
  _discount: "Disc.",
  _duration: "Dur.",
  _entry_count: "E.",
  _exchange_rate: "Exch.r.",
  _from_store: "Source",
  _isInventoryItem: "I.",
  _isTop: "M.",
  _item: "Item",
  _last_status: "Last st.",
  _multiplicator: "Mult.",
  _name: "Name",
  _net_price: "Net price",
  _net_unit_price: "N. u. price",
  _online: "W.",
  _option: "Opt.",
  _order_sequence_number: "O. nr.",
  _orders: "O.nr.",
  _paid_by: "Paid",
  _payment_method: "Payment m.",
  _persons: "P.",
  _production_line: "P. line",
  _profit_margin: "Margin",
  _quantioty_type: "Q. t.",
  _quantity: "Quantity",
  _quantity_type: "Qty. type",
  _recalculateConsumption: "Recalc. stock",
  _seqnr: "Seq.nr.",
  _service_fee: "Service fee",
  _settings: {
    business_day_ends_at: {
      description: "In hours, may be less than the start, e.g., 5 AM when the business day ends after midnight",
      title: "Business Day End"
    },
    business_day_starts_at: {
      description: "In hours",
      title: "Business Day Start"
    },
    compulsory_service_fee: {
      description: "Automatic service charge application for non-cash register tables, adjustable before invoice printing.",
      title: "Mandatory Service Charge"
    },
    compulsory_service_fee_for_pos: {
      description: "Automatic service charge application for cash register tables.",
      title: "Mandatory Service Charge for Cash Register"
    },
    day: "day",
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "date"],
    description_footer: {
      title: "Webshop Footer Content"
    },
    description_header: {
      title: "Webshop Header Content"
    },
    drinks: {
      default: {
        description: "Default display of drinks or meals on ordering by waiter and webshop.",
        title: "Default"
      },
      enabled: {
        title: "Enabled"
      },
      label: {
        description: "Label to display on webshop.",
        title: "Label"
      },
      title: "Settings: Drinks"
    },
    email: "email address",
    "hellopay-user-code": {
      description: "The HelloPay user ID determines where the tip is transferred. If it is not set, the tip is sent to the same destination as the bill total. To configure it, contact support.",
      title: "HelloPay user ID"
    },
    en: "English",
    enabled_features: {
      homedelivery: {
        allowed_installments: {
          by_each: "Daily payment",
          description: "Payment installment options for menu orders",
          end: "Payment at the end",
          start: "Prepayment",
          title: "Payment installment options"
        },
        autoclose: {
          description: "Auto close paid and delivered orders",
          title: "Automatic closure"
        },
        "available-timeslots": {
          description: "These time slots are available for delivery through the webshop",
          title: "Delivery time slots"
        },
        blockWaiterClose: {
          description: "Only administrators can close a homedelivery.",
          title: "Block closure to waiters"
        },
        copy_order_email: {
          description: "Who should receive email notifications about webshop orders and status changes",
          title: "Email notification"
        },
        dayends: {
          description: "Until what time can orders be placed for the same day in the webshop",
          title: "Day cutoff"
        },
        delays: {
          description: "Available durations for confirmed preparation/delivery in minutes for Wolt/Foodpanda",
          title: "Estimated delivery time"
        },
        encode_seqnr: {
          description: "Encrypt the order number for the customer",
          title: "Secret order number"
        },
        homedelivery_menuitem: {
          description: "When applying a zip code-based home delivery fee, which product does the system use. If such a product does not exist yet, create a new product named 'Home Delivery Fee', save it, reopen it for editing, note down its ID, and enter it here.",
          title: "Product ID for home delivery fee"
        },
        instantOrderOnly: {
          description: "Only accept instant orders in the webshop",
          title: "Instant orders only"
        },
        "min-duration": {
          description: "How long is the delivery time slot in hours",
          title: "Delivery time slot duration"
        },
        orderedStatus: {
          description: "Initial status of items ordered on the webshop",
          title: "Status after order"
        },
        autoaccept: {
          description: "Automatic acceptance of items ordered on the webshop",
          title: "Automatikus elfogadás"
        },
        orderedAutoStatus: {
          description: "Status of items ordered on the webshop when the order is automatically accepted",
          title: "Automatically accepted order status"
        },
        phone_order_fee: {
          description: "System usage fee for phone orders",
          title: "System usage fee"
        },
        price: {
          above_amount: "Above amount",
          area: {
            description: "Draw the delivery region on the map",
            title: "Map"
          },
          courierFee: {
            description: "Courier fee for home delivery",
            title: "Courier Fee"
          },
          description: "You have the option to automatically charge a delivery fee based on zip code and order value",
          except: {
            description: "Except for products with label",
            title: "Except"
          },
          name: "Name",
          only: {
            description: "Only for products with label",
            title: "Only"
          },
          price: "Delivery fee",
          title: "Delivery fee",
          zip: "Zip code"
        },
        printInvoiceOnOrder: {
          description: "After new orders is submited automatically print the invoice as well.",
          title: "Automatic invoice printing"
        },
        printAllLabels: {
          description: "Show the bulk label-print button in the home delivery occupation selector.",
          title: "Print all delivery labels"
        },
        send_email_on: {
          description: "When webshop orders reach which status, send email notifications to the addresses above",
          title: "Send email on status"
        },
        "table-number": {
          description: "The table number for handling home delivery orders",
          title: "Table number"
        },
        "terms-and-conditions": {
          description: "Inform your customers about the home delivery conditions when placing webshop orders",
          title: "General terms and conditions"
        },
        timeahead: {
          description: "For manual or webshop orders, how many hours in advance do you guarantee delivery",
          title: "Delay"
        },
        user_allowed_installments: {
          by_each: "Daily payment",
          description: "Payment installment options for menu orders in the webshop",
          end: "Payment at the end",
          start: "Prepayment",
          title: "Payment installment options in the webshop"
        },
        webshop_order_fee: {
          description: "System usage fee for webshop orders",
          title: "System usage fee"
        },
        zip: {
          description: "Which zip codes does the system accept (regexp)",
          title: "Zip code"
        }
      },
      pickup: {
        allowed_installments: {
          by_each: "Daily payment",
          description: "Payment installment options for menu orders",
          end: "Payment at the end",
          start: "Prepayment",
          title: "Payment installment options"
        },
        autoclose: {
          description: "Auto close paid and delivered orders",
          title: "Automatic closure"
        },
        "available-timeslots": {
          description: "These time slots are available for pickup orders through the webshop",
          title: "Pickup time slots"
        },
        copy_order_email: {
          description: "Who should receive email notifications about webshop orders and status changes",
          title: "Email notification"
        },
        dayends: {
          description: "Until what time can orders be placed for the same day in the webshop",
          title: "Day cutoff"
        },
        delays: {
          description: "Available durations for confirmed preparation for Wolt/Foodpanda in minutes",
          title: "Estimated pickup time"
        },
        encode_seqnr: {
          description: "Encrypt the order number for the customer",
          title: "Secret order number"
        },
        instantOrderOnly: {
          description: "Only accept instant orders in the webshop",
          title: "Instant orders only"
        },
        "min-duration": {
          description: "How long is the pickup time slot in hours",
          title: "Pickup time slot duration"
        },
        orderedStatus: {
          description: "Initial status of items ordered on the webshop",
          title: "Status after order"
        },
        autoaccept: {
          description: "Automatic acceptance of items ordered on the webshop",
          title: "Automatic acceptance"
        },
        orderedAutoStatus: {
          description: "Status of items ordered on the webshop when the order is automatically accepted",
          title: "Automatically accepted order status"
        },
        phone_order_fee: {
          description: "System usage fee for phone orders",
          title: "System usage fee"
        },
        send_email_on: {
          description: "When webshop orders reach which status, send email notifications to the addresses above",
          title: "Send email on status"
        },
        "table-number": {
          description: "The table number for handling pickup orders",
          title: "Table number"
        },
        "terms-and-conditions": {
          description: "Inform your customers about the pickup order conditions when placing webshop orders",
          title: "General terms and conditions"
        },
        timeahead: {
          description: "For manual or webshop orders, how many hours in advance do you guarantee order preparation",
          title: "Delay"
        },
        user_allowed_installments: {
          by_each: "Daily payment",
          description: "Payment installment options for menu orders in the webshop",
          end: "Payment at the end",
          start: "Prepayment",
          title: "Payment installment options in the webshop"
        },
        webshop_order_fee: {
          description: "System usage fee for webshop orders",
          title: "System usage fee"
        }
      },
      prebooking: {
        bookingDelay: {
          description: "Booking can be made only this amount of minutes after now",
          title: "Booking lead time"
        },
        defaultBookingMinutes: {
          description: "Default duration (minutes) when making a reservation on the web",
          title: "Default Duration on Webshop"
        },
        defaultDuration: {
          description: "Default duration (minutes) when making a reservation",
          title: "Default Duration"
        },
        maxBookingMinutes: {
          description: "Maximum duration (in minutes) for reservations on the web",
          title: "Maximum Duration"
        },
        maxLateDuration: {
          description: "Allowed grace period (in minutes) for guest arrival before the reservation is deleted",
          title: "Allowed Lateness"
        },
        minBookingMinutes: {
          description: "Minimum duration (in minutes) for reservations on the web",
          title: "Minimum Duration"
        },
        openingHours: {
          description: "Opening hours on the web",
          slots: {
            description: "Time slot for opening hours (e.g., from 10:00 to 14:00)",
            title: "Time Slot"
          },
          title: "Opening Hours"
        },
        seats: {
          description: "These numbers of persons can be chosen on the web",
          title: "Number of Persons"
        },
        showBefore: {
          description: "Show reservations on the floor plan this many minutes before",
          title: "Show This Many Minutes Before"
        },
        slotMinutes: {
          description: "These durations can be chosen on the web",
          title: "Durations"
        }
      },
      pos: {
        customerScreenButton: {
          title: "Customer screen features",
          enabled: {
            title: "Customer screen button",
            description: "Enable the customer screen button in POS."
          }
        },
        askForTipOnCardPayment: {
          title: "Ask for tip on card payment",
          description: "Ask for tip on customer screen for card payments when card terminal integration is enabled."
        },
        askForTipOnAllPayment: {
          title: "Ask for tip on all payments",
          description: "Ask for tip on customer screen for every payment method, including cash."
        },
        askForTipOnAnyCardPayment: {
          title: "Ask for tip on any card payment",
          description: "Ask for tip on customer screen for any card payment method, even when card terminal integration is not enabled."
        },
        askForTipOnCashPayment: {
          title: "Ask for tip on cash payment",
          description: "Ask for tip on customer screen when cash payment is used."
        },
        mandatoryAskForTipOnCardPayment: {
          title: "Mandatory tip selection during payment",
          description: "Makes tip selection mandatory on the customer screen during payment; it cannot be skipped by double-clicking the payment button."
        },
        multiLogin: {
          title: "Multi-login in POS",
          description: "Allow multiple users to stay logged in on POS at the same time."
        },
        payFirst: {
          title: "Pay first",
          description: "Require payment before order fulfillment."
        },
        dontUnlock: {
          title: "Do not unlock table after payment",
          description: "Do not unlock the table automatically after payment."
        },
        tips: {
          title: "Tip percentage options",
          description: "Preset tip percentage options shown on the customer screen."
        }
      }
    },
    from_hour: "from hour",
    fromday: "from date",
    hu: "Hungarian",
    meals: {
      default: {
        description: "Default display of drinks or meals on ordering by waiter and webshop.",
        title: "Default"
      },
      enabled: {
        title: "Enabled"
      },
      label: {
        description: "Label to display on webshop.",
        title: "Label"
      },
      title: "Settings: Meals"
    },
    menu: {
      show_category_image: {
        title: "Show Images for Product Categories"
      },
      show_menuitem_image: {
        title: "Show Images for Products"
      },
      title: "Ordering Interface, Product Selector"
    },
    minute: "minute",
    payment_method: {
      meth: {
        title: "Method"
      },
      term: {
        description: "Payment terms for webshop",
        title: "Payment Terms"
      },
      title: "Available Payment Methods"
    },
    price_calculations: {
      increase_price: {
        above: {
          description: "Price increases if the new price is higher than the original price by a specified percentage or amount. e.g., 0% means any increase will apply.",
          dscription: "Az ár akkor növekszik, ha az árnövekedés utáni ár magasabb mint az eredeti ár adott százaléka vagy adott összeg. pl. 0% azt jelenti, hogy bármilyen növekény érvényesülni fog.",
          title: "Price Increase If"
        },
        measure: {
          title: "Measure Type"
        },
        title: "Price Increase Logic"
      },
      lower_price: {
        above: {
          description: "Price decreases if the new price is lower than the original price by a specified percentage or amount. e.g., 100% means any reduction will apply.",
          dscription: "Az ár akkor csökken, ha az árcsökkenés utáni ár alacsonyabb mint az eredeti ár adott százaléka vagy adott összeg. pl. 100% azt jelenti, hogy bármilyen csökkenés érvényesülni fog.",
          title: "Price Reduction If"
        },
        description: "Default components/options can be removed/disabled or replaced when ordering.",
        measure: {
          title: "Measure Type"
        },
        title: "Price Reduction Logic"
      },
      rounding: {
        description: "e.g., 1 -> rounds to nearest whole number, 50 -> rounds to 50 or 100.",
        title: "Rounding"
      },
      title: "Price Calculation Logic"
    },
    printing: {
      invoice: {
        title: "Invoice Layout"
      },
      showAllComments: {
        description: "By default, only cost-modifying comments are visible.",
        title: "Show All Comments on Invoice"
      },
      showOrderNumber: {
        description: "Default for cash orders.",
        title: "Show Order Number on Normal Tables"
      },
      title: "Printing Settings"
    },
    qrstart: {
      description: "Display QR code at the beginning of the invoice.",
      title: "QR Code Position"
    },
    qstart: {
      description: "Display QR code at the beginning of the invoice",
      title: "QR Code Position"
    },
    register_tip: {
      description: "Register the difference as a tip if the amount paid exceeds the amount due.",
      title: "Register Tip"
    },
    service_fee: {
      description: "e.g., 12 if a 12% service charge is typically applied. The service charge's application and rate can be set or adjusted on invoice printing.",
      title: "Service Charge"
    },
    serviceVat: {
      description: "Separate service charges by VAT categories on invoice/receipt.",
      title: "Separated Service Charge"
    },
    states: ["deleted", "selected", "ordered", "confirmed", "in progress", "ready", "delivery", "delivered"],
    tables_overview: {
      title: "Table Overview Operation"
    },
    "tables-overview": {
      always_allow_delete: {
        description: "Allow deletion even for waiter permissions",
        title: "Allow deletion"
      },
      askPersonCount: {
        description: "Request number of guests when occupying table to determine cart size",
        title: "Request Number of Persons"
      },
      "auto-table-qrcode": {
        description: "With the printing of the first orders print the qr-code as well",
        title: "Print QR-code autmatically"
      },
      autoDeliverOnUnlock: {
        description: "After freeing up the table, any non-deleted items are automatically set to 'delivered' status and deducted from inventory",
        title: "Automatic delivery mode"
      },
      autolock: {
        description: "After a set time, the screen locks and can only be unlocked with a passcode or password.",
        title: "Automatic screen lock"
      },
      bigAdditions: {
        description: "Bigger +/- lines on kitchen receipt",
        title: "Bigger font size on kitchen receipt"
      },
      bigOrderNumber: {
        description: "Print a larger order number on the kitchen receipt than the default setting",
        title: "Large order number"
      },
      block_waiter_print_daily_closing: {
        description: "Prohibition of querying current traffic data for waiters",
        title: "Prohibition of fast traffic data"
      },
      block_waiter_print_invoice: {
        description: "Block printing of invoice by waiters",
        title: "Block printing of invoice"
      },
      block_waiter_register_payment: {
        description: "Block payment registration by waiters",
        title: "Block payment registration"
      },
      delayed_orders_browser: {
        description: "Orders are sent to the server only upon confirmation.",
        title: "Delayed Order Submission from Browser"
      },
      delayed_orders_mobile: {
        description: "Orders are sent to the server only upon confirmation.",
        title: "Delayed Order Submission from Mobile App"
      },
      doubleWide: {
        description: "",
        title: "Double wide fonts for kitchen receipts"
      },
      drinkOrderStatus: {
        description: "",
        title: "Drink order status on ordering"
      },
      extra_charge_on_takeaway: {
        description: "Apply an extra charge on takeaway orders",
        title: "Extra charge on takeaway"
      },
      hideMenuCategoryImage: {
        description: "Hide category pictures from ordering screen",
        title: "Hide category pictures"
      },
      hideMenuItemImage: {
        description: "Hide protduct pictures from ordering screen",
        title: "Hide product pictures"
      },
      kitchenQrCode: {
        description: "QR Code can be used for kitchen/bar order reporting when scanned with appropriate QR reader",
        title: "Print QR Code on Kitchen/Bar Receipt"
      },
      lessKioskButtons: {
        description: "Display the fewest possible buttons in cash register mode",
        title: "Fewer buttons in cash register mode"
      },
      mealOrderStatus: {
        description: "",
        title: "Meal order status on ordering"
      },
      newOrdersKioskStatesShown: {
        description: "Which statuses (columns) to show for tables in cash register mode",
        title: "States shown in cash register mode"
      },
      newOrdersStatesShown: {
        description: "Which statuses (columns) to show for new order entries",
        title: "States shown on order entry"
      },
      "notify-customer-when-part-ready": {
        description: "When a course is prepared on multiple production lines notify the customer even when not all production lines are ready with their part",
        title: "Notify customer when course part ready"
      },
      "notify-waiter-when-part-ready": {
        description: "When a course is prepared on multiple production lines notify the waiter even when not all production lines are ready with their part",
        title: "Notify waiter when course part ready"
      },
      perPersonKitchenReceipt: {
        description: "For example, when each person's order needs to be served on a separate tray",
        title: "Per-person separated kitchen receipt"
      },
      pos_delayed_orders_browser: {
        description: "Orders are sent to the server only upon confirmation.",
        title: "Delayed Order Submission from Browser in POS Mode"
      },
      pos_delayed_orders_mobile: {
        description: "Orders are sent to the server only upon confirmation.",
        title: "Delayed Order Submission from Mobile App in POS Mode"
      },
      print_accepted_customer_orders: {
        description: "Automatically print webshop orders upon confirmation",
        title: "Automatic printing upon confirmation"
      },
      states: {
        description: "Which order states to consider",
        title: "Filter states"
      },
      statesShown: {
        description: "Which statuses (columns) to show when opening a table",
        title: "States shown"
      },
      "table-qrcode": {
        description: "",
        enumNames: ["None", "Payment only", "Connection"],
        title: "Functionality of the printed QR code for the table"
      },
      timeout: {
        description: "After how many seconds should the screen lock",
        title: "Lock delay"
      },
      unlockOnPayment: {
        description: "Automatic release of the table upon payment if there are no more unpaid items",
        title: "Automatic release"
      },
      waiter_print_daily_closing_full: {
        description: "Complete current traffic data for waiters",
        title: "Full fast traffic data"
      }
    },
    takeaway: {
      containerChargeItem: {
        title: "Deposit Product Identifier"
      },
      default: {
        description: "Enable automatic takeaway for cash registers",
        title: "Default"
      },
      enabled: {
        title: "Enabled"
      },
      packageChargeItem: {
        title: "Packaging Product Identifier"
      },
      price: {
        description: "Option to specify an extra takeaway price on the product page.",
        title: "Separate Takeaway Price"
      },
      systemFeeItem: {
        title: "System usage fee Product Identifier"
      },
      title: "Takeaway",
      vat: {
        title: "Default VAT for Takeaway"
      }
    },
    timezone: {
      title: "Timezone"
    },
    timings: {
      enabled: {
        title: "Enabled"
      },
      enabled_online: {
        title: "Enabled for Onsite Orders on Webshop"
      },
      langs: {
        lang: {
          title: "Language"
        },
        name: {
          title: "Label"
        },
        name_online: {
          title: "Label on Webshop"
        },
        title: "Language Labels"
      },
      title: "Courses"
    },
    to_hour: "to hour",
    today: "to date"
  },
  _split_invoice: "Split",
  _supplier_code: "Supplier c.",
  _tip: "Tip",
  _to_store: "Target",
  _top_category: "Top cat.",
  _unit_price: "Price",
  _vat_category: "VAT",
  accept_homedelivery_terms: "I agree with the home delivery conditions",
  accept_pickup_terms: "I agree with the pickup conditions",
  accept_privacy_terms: "I accept the privacy policy",
  "Access denied": "Access denied",
  access_denied: "Access denied: {0}",
  access_tokens: "Access tokens",
  action_failed: "Unsuccessful operation. It's possible that something isn't up-to-date; let's synchronize and then try the operation again!",
  action_not_allowed: "You have no permission to perform this action",
  activate: "Activate",
  activate_booking: "Activate booking",
  activate_sound: "Bell activated",
  active: "Active",
  active_average_acceptance_duration: "Average order acceptance",
  active_average_delivering_duration: "Average order delivery",
  active_max_acceptance_duration: "Highest order acceptance",
  active_max_delivering_duration: "Highest order delivery",
  active_min_acceptance_duration: "Lowest order acceptance",
  active_min_delivering_duration: "Lowest order delivery",
  add: "Add",
  add_category: "New category",
  add_item: "New item",
  add_meal: "New meal",
  add_meal_category: "New category",
  add_option: "New option",
  add_role: "New role",
  add_room: "Add room",
  add_user: "New user",
  addlogin: "Login additional user",
  address: "Address",
  address_pattern: "^.+ (street|square|park) \\d+\\.?$",
  address_pattern2: "[^,].+ (hrsz|arok|atjaro|dulo|dulout|erdosor|fasor|fordulo|gat|hatarsor|határút|kapu|körönd|körtér|körút|köz|lakótelep|lejáró|lejtő|lépcső|liget|mélyút|orom|ösvény|park|part|pincesor|rakpart|sétány|sikátor|sor|sugárút|tér|udvar|ut|utca|üdülőpart)",
  address_placeholder: "Format: name (street|square|etc.) number.",
  afterPrint: "After printing",
  agree: "Provide my consent",
  alias: "Global id",
  all: "All",
  all_items: "All",
  all_production_lines: "All production lines",
  allergens: "Allergens",
  allergens_tooltip: "<div class='allergen-gluten'>The product does not contain the given allergen</div><div class='allergen-gluten has'>The product contains the given allergen</div><div class='allergen-gluten inherited'>The product contains the given allergen through inheritance or recipe</div><div class='allergen-gluten has removable'>The product can be prepared without the given allergen</div>",
  allowed_installments: {
    by_each: "Daily",
    end: "At the end",
    start: "In advance"
  },
  already_paid_reprint_invoice: "Bill already settled! Do you really want to reprint the invoice?",
  ambience: "Ambience",
  amount: "Amount",
  amount_paid: "Paid",
  amount_to_pay: "Payable",
  ap: "AP Number",
  apply_type_discount: "Apply discount",
  "Are you sure you want to change for a different customer? The new email is different to the already given one!": "Are you sure you want to change for a different customer? The new email is different to the already given one!",
  "Are you sure you want to change for a different customer? The new phone number is different to the already given one!": "Are you sure you want to change for a different customer? The new phone number is different to the already given one!",
  are_you_sure_you_cancel_the_payment: "Are you sure you cancel registering the payment details?",
  are_you_sure_you_want_to_delete: "Are you sure you want to delete",
  are_you_sure_you_want_to_delete_the_cashregister: "Are you sure you want to delete cash register <b>{0}</b>",
  are_you_sure_you_want_to_delete_the_discount_type: "Are you sure you want to delete discount type <b>{0}</b>",
  are_you_sure_you_want_to_delete_the_floorplan: "Are you sure you want to delete the floorplan <b>{0}</b>?",
  are_you_sure_you_want_to_delete_the_incoming_stock: "Are you sure you want to delete the selected incoming stock entry?",
  are_you_sure_you_want_to_delete_the_inventory: "Are you sure you want to delete the selected inventory entry?",
  are_you_sure_you_want_to_delete_the_label: "Are you sure you want to delete label <b>{0}</b>?",
  are_you_sure_you_want_to_delete_the_printer: "Are you sure you want to delete printer <b>{0}</b>",
  are_you_sure_you_want_to_delete_the_production_line: "Are you sure you want to delete the label <b>{0}</b>",
  are_you_sure_you_want_to_delete_the_quantity_type: "Are you sure you want to delete serving <b>{0}</b>",
  are_you_sure_you_want_to_delete_the_room: "Are you sure you want to delete <b>room {0}</b>",
  are_you_sure_you_want_to_delete_the_store: "Are you sure you want to delete the warehouse <b>{0}</b>",
  are_you_sure_you_want_to_delete_the_table: "Are you sure you want to delete <b>table {0}</b>",
  are_you_sure_you_want_to_delete_the_vat_category: "Are you sure you want to delete VAT category <b>{0}</b>",
  are_you_sure_you_want_to_delete_traffic_until: "Are you sure you want to delete the traffic until <strong>{0}</strong>",
  assign_to_me: "Assign to me",
  assistance_needed: "Waiter called",
  authenticate: "Authenticate",
  authenticate_gba: "Authenticate Google Business Profile",
  auto_commit_imcoming_stocks: "Aut. commit",
  auto_commit_incoming_stocks_tooltip: "Generate automatic and final (non-draft) stock entries based on incoming invoices from this supplier, instantly updating the inventory.",
  auto_import_incoming_stocks: "Aut. intake",
  auto_import_incoming_stocks_tooltip: "Generate stock entries automatically based on incoming invoices from this supplier.",
  auto_translate: "Translate",
  automatic: "Automatic",
  available: "Available",
  available_quantity: "Available quantities",
  averageCost: "Average cost",
  averagePrice: "Average price",
  back: "Back",
  backup: "Backup",
  backup_url: "BCK url",
  barcode: "Barcode",
  barcode_found_but_no_menuitem: "Barcode found, but no local product is connected in the system.",
  barcode_not_found: "Unknown barcode!",
  barcode_found_in_global_db: "Barcode found in global database",
  select_local_product: "Select local product to link:",
  link_and_continue: "Link & Continue",
  skip: "Skip",
  barcode_not_in_global_db: "Barcode not found in global database",
  create_new_barcode_question: "This barcode is not known. Do you want to create a new local entry?",
  create_new_barcode: "Create new barcode",
  modify_barcode: "Modify barcode",
  no_product_linked: "No product is linked to this barcode. Please select a product.",
  create_barcode_hint: "Only for water-like liquids where we can calculate weight from capacity. The bottle must be measured empty or full.",
  calibration_bottle_hint: "For this calibration step, place a completely full or completely empty bottle of this product on the scale.",
  measuring_calibration: "Measuring calibration bottle, place on scale...",
  measuring_actual: "Measuring the actual bottle...",
  place_actual_bottle: "Calibration done. Now place the actual bottle on the scale and press Measure.",
  measure_now: "Measure",
  calibration_result: "Calibration result",
  approve_and_save: "Approve & Save",
  estimated_weight: "Estimated weight",
  measured_empty_bottle_weight: "Measured empty bottle weight",
  measured_full_bottle_weight: "Measured full bottle weight",
  estimated_empty_bottle_weight: "Estimated empty bottle weight",
  estimated_full_bottle_weight: "Estimated full bottle weight",
  remeasure_empty_bottle: "Re-measure with empty bottle",
  remeasure_full_bottle: "Re-measure with full bottle",
  barcode_name: "Name",
  capacity_cl: "Capacity (cl)",
  bottle_state: "Bottle state during measurement",
  bottle_full: "Full",
  bottle_empty: "Empty",
  photo: "Photo",
  take_photo: "Take photo",
  measure_and_save: "Measure & Save",
  edit_details: "Edit details",
  back_to_results: "Back to results",
  measured_weight: "Measured weight",
  measuring: "Measuring, place item on scale...",
  required_fields: "Please fill in the required fields",
  basic_data: "Basic data",
  below_criticalStock: "Product below critical quantity, endangering business operations",
  below_minimumStock: "Product below minimum quantity, when we typically restock",
  bizpay: {
    error: {
      unknown: "Card payment failed"
    }
  },
  book_a_table: {
    not_enough_free_tables: "There are not enough free tables in any of the rooms!",
    not_free_table: "There are no free table in any of the rooms!",
    number_of_seats: "{0} seats",
    provide_comment: "Comment",
    provide_email: "Email",
    provide_name: "Name",
    provide_name_or_email: "Enter guest's name or email",
    provide_phone: "Phone number",
    room: "Room",
    rooms: "Rooms",
    seats: "Seats",
    tables: "Tables",
    title: "Book a table"
  },
  book_online: "Bookable to guests",
  booking_comment: "Note",
  brutto_income: "Income",
  brutto_price: "Brutto price",
  brutto_unit_price: "Brutto unit price",
  by_drink_or_meal_tab: "By meal or drink",
  by_occupation_start: "By time of order",
  by_payment: "By time of payment",
  by_person_tab: "By person",
  by_timing_tab: "By course",
  calendar: "Calendar",
  calorie: "Calorie",
  cancel: "Cancel",
  cancel_b: "Cancel",
  cancel_booking: "Cancel booking",
  cancel_paying: "Cancel bill",
  cancelled_orders: "Deleted",
  cartsize: "Cart size",
  cashier: "Cashier",
  cashier_dayclose: "Close day",
  cashier_dayopen: "Open day",
  cashier_open_amount: "Opening cash",
  cashin: {
    montax: {
      CHANGE: "Cash Float Deposit",
      CASHIER_DEPOSIT: "Cashier Cash Withdrawal",
      COLLECTION: "Fee Collection",
      LOTTERY_TICKET_SALE: "Lottery Ticket Sale",
      DEPOSIT: "Advance Payment",
      DEFICIT: "Cash Register Shortage",
      TIP: "Tip",
      OTHER_CASH_IN: "Other Deposit"
    },
    a234: {
      "0": "Cash Float Deposit",
      "1": "Cashier Cash Withdrawal",
      "2": "Fee Collection",
      "3": "Lottery Ticket Sale",
      "4": "Advance Payment",
      "5": "Cash Register Shortage",
      "6": "Tip",
      "7": "Other Deposit"
    },
    b1: {
      "1": "Cash Float Deposit",
      "2": "Cashier Cash Withdrawal",
      "3": "Fee Collection",
      "4": "Lottery Ticket Sale",
      "5": "Advance Payment",
      "6": "Cash Register Shortage",
      "7": "Tip",
      "8": "Other Deposit"
    },
    fiscat: {
      "01": "Cash Float Deposit",
      "02": "Cashier Cash Withdrawal",
      "03": "Fee Collection",
      "04": "Lottery Ticket Sale",
      "05": "Advance Payment",
      "06": "Cash Register Shortage",
      "07": "Tip",
      "08": "Other Deposit"
    },
    reason: "Reason for Cash Deposit",
    sam4s: {
      "1": "change money input",
      "2": "cashier money withdrawal",
      "3": "fee collection",
      "4": "lottery ticket sale",
      "5": "advance payment",
      "6": "cash register shortage",
      "7": "tip",
      "8": "other deposit"
    },
    sam4s2: {
      "1": "change money input",
      "2": "cashier money withdrawal",
      "3": "fee collection",
      "4": "lottery ticket sale",
      "5": "advance payment",
      "6": "cash register shortage",
      "7": "tip",
      "8": "other deposit"
    },
    title: "Cash Deposit"
  },
  cashout: {
    montax: {
      SKIMMING: "Skim",
      CASHIER_WITHDRAWAL: "Cashier Payout",
      VOUCHER_OUT: "Voucher Payout",
      GIFT_CARD_OUT: "Gift Card Payout",
      SALARY_PAYMENT: "Salary Payout",
      ADVANCE_PAYMENT: "Wage Advance",
      POSTAL_FEE: "Postage Cost",
      OTHER_FEES: "Other Expense",
      PROCUREMENT: "Goods Purchase",
      TURNOVER_WITHDRAWAL: "Total Payout",
      OTHER_CASH_OUT: "Other Payout"
    },
    a234: {
      "0": "Skim",
      "1": "Cashier Payout",
      "10": "Other Payout",
      "2": "Voucher Payout",
      "3": "Gift Card Payout",
      "4": "Salary Payout",
      "5": "Wage Advance",
      "6": "Postage Cost",
      "7": "Other Expense",
      "8": "Goods Purchase",
      "9": "Total Payout"
    },
    b1: {
      "31": "Skim",
      "32": "Cashier Payout",
      "41": "Other Payout",
      "33": "Voucher Payout",
      "34": "Gift Card Payout",
      "35": "Salary Payout",
      "36": "Wage Advance",
      "37": "Postage Cost",
      "38": "Other Expense",
      "39": "Goods Purchase",
      "40": "Total Payout"
    },
    fiscat: {
      "31": "Skim",
      "32": "Cashier Payout",
      "33": "Voucher Payout",
      "34": "Gift Card Payout",
      "35": "Salary Payout",
      "36": "Wage Advance",
      "37": "Postage Cost",
      "38": "Other Expense",
      "39": "Goods Purchase",
      "40": "Total Payout",
      "41": "Other Payout"
    },
    reason: "Reason for Cash Payout",
    sam4s: {
      "1": "skimming",
      "10": "closing amount withdrawal",
      "11": "other payout",
      "2": "cashier withdrawal",
      "3": "voucher withdrawal",
      "4": "gift card withdrawal",
      "5": "salary payment",
      "6": "wage advance",
      "7": "postal cost",
      "8": "other utility",
      "9": "goods purchase"
    },
    sam4s2: {
      "1": "skimming",
      "10": "closing amount withdrawal",
      "11": "other payout",
      "2": "cashier withdrawal",
      "3": "voucher withdrawal",
      "4": "gift card withdrawal",
      "5": "salary payment",
      "6": "wage advance",
      "7": "postal cost",
      "8": "other utility",
      "9": "goods purchase"
    },
    title: "Cash Payout"
  },
  cashRegister: "Cash register",
  categories_or_menuitems: "Menu items or categories",
  category: "Category",
  celery: "celery",
  cash_return: "Change due",
  change: "Change",
  change_table: "Change table",
  change_table_number: "Change table",
  changeit: "Change it",
  channels: {
    console: "Console",
    console_homedelivery: "",
    console_pickup: "",
    falatozz: "Falatozz",
    foodora: "Foodora",
    webshop_homedelivery: "Webshop",
    webshop_onsite: "Webshop",
    webshop_pickup: "Webshop",
    wolt: "Wolt"
  },
  charwidth: "Character width",
  checkbox_option: "Multiple options can be selected from the category when ordering",
  checkbox_option2: "Keep as separate option category. Multiple options can be selected from the category when ordering",
  choose_customer_for: "Choose customer for person {0}.",
  choose_parent_category: "Choose parent category",
  choose_terminal_to_use: "Choose bank terminal",
  city: "City",
  clear: "Clear",
  close: "Close",
  close_order: "Cancel",
  closed: "Closed",
  collaborating_production_lines: "Collaborating",
  comment: "Comment",
  comments: "Comments",
  company: "Restaurant/Company name",
  company_name: "Company name",
  confirm: {
    deleteResources: "Are you sure you want to delete the following resources:",
    deleteRole: "Are you sure you want to delete the role",
    undoAction: "This action cannot be undone."
  },
  confirm_additional_table: "Do you add table no. {0} to the current occupation?",
  confirm_change_to_homedelivery: "Change for homedelivery?",
  confirm_change_to_pickup: "Change for pickup?",
  confirm_change_to_table: "Everybody changes to table no. {0}?",
  confirm_customer_deletion: "Are you sure you want to delete user <b>{0}</b>?",
  confirm_not_printing: "Dou you really want to skip printing the orders?",
  confirm_person_change_to_empty_table: "Person {0}. changes to empty table no. {1}? <br/>As new occupation or as part of the current one?",
  confirm_person_change_to_multiple_occupation_table: "Person {0}. changes already occupied table no. {1}?",
  confirm_person_change_to_shared_table: "Person {0}. changes to the already occupied table no. {1}?<br/>As new occupation or joins the existing one?",
  confirm_person_change_to_table: "Person {0}. joins the already occupied table no. {1}?",
  confirm_position_update: "Refresh GPS coordinates for address",
  confirm_role_deletion: "Are you sure you want to revoke the <b>{1}</b> access to <b>{2}</b> from <b>{0}</b>?",
  confirm_table_change_to_shared_table: "Target table is a shareable table. Please choose between the available options.",
  confirm_table_change_to_table: "The whole table joins the already occupied table {0}.?",
  confirmation_copy_all: "Do you want to synchronize all products in the category?",
  connected_from: "Connected",
  connected_restaurant: "Connected restaurant",
  connected_restaurants: "Connected restaurants",
  connection: "Connection",
  "Connection error with the cash register": "Connection error with the cash register",
  consumption: "Sold volume",
  container_charge: "Container charge",
  container_charge_onsite: "Also in case of local consumption",
  continue_in: "After {0} minute(s) this warning will close. Please wait...",
  continue_ordering: "Continue ordering",
  continue_without_open_day: "Continue anyhow",
  controlled_production_lines: "Changing status altogether",
  cost: "Cost",
  cost_estimation: "Cost estimation",
  could_not_find_this_order: "Order no. {0} not found!",
  could_not_find_this_order2: "Order not found!",
  count: "Count",
  country: "Country",
  courier: "Courier",
  courier_delivering: "Delivering",
  courier_delivery_continue: "Continue delivery",
  courier_delivery_pause: "Pause delivery",
  courier_off: "Off work",
  courier_pause: "Pause",
  courier_ready: "Waiting for delivery",
  courierFee: "Courier fee",
  couriers: "Couriers",
  created_by: "Created",
  criticalStock: "Critical quantity that jeopardizes business operations",
  cron: {
    andText: "and",
    atEveryText: "At/Every",
    atOptionLabel: "at",
    betweenText: "between",
    cronDescriptionText: "en",
    dayOfMonthLabel: "Day(s)",
    dayOfWeekLabel: "Day of week",
    everyOptionLabel: "every",
    everyText: "Every",
    hourLabel: "Hour(s)",
    inText: "in",
    lastDayOfMonthLabel: "Last day of month",
    minuteLabel: "Minute(s)",
    monthLabel: "Month(s)",
    multiDayOfMonthLabel: "Day of month",
    onEveryText: "On/Every",
    onOptionLabel: "on",
    onText: "on",
    periodLabel: "Period",
    periodOptions: ["hour", "day", "week", "month", "year"],
    shortMonthOptions: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
    weekDaysOptions: ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"]
  },
  crustaceans: "crustaceans",
  cumulative: "Cumulative",
  currencies: "Currencies",
  currency: "Currency",
  custom_range: "Custom range",
  custom_reason: "Custom reason",
  customer_table: {
    search: "Search",
    name: "Name",
    surname: "Surname",
    email: "Email",
    phone: "Phone",
    address: "Address",
    city: "City",
    postcode: "Postcode",
    country: "Country",
    labels: "Labels",
    delete: "Delete",
    loading: "Loading...",
    no_results: "No results",
    items_per_page: "Per page",
    showing: "Showing",
    of: "of",
    previous: "Previous",
    next: "Next",
    import: "Import",
    import_preview: "Import preview",
    import_confirm: "Import now",
    preview_rows: "Previewing {0} rows",
    import_result: "Imported {0}, updated {1}, skipped {2}",
    import_invalid: "Only CSV, XLS or XLSX files are supported.",
    original_excel: "Original Excel",
    after_mapping: "After mapping",
    primary: "Primary",
    fallback: "Fallback"
  },
  customer_details: "Customer details",
  customer_orders: "New customer orders",
  customerAddress: "Customer address",
  customerName: "Customer name",
  customerOrder: "Consumer order (webshop)",
  customerPostCode: "Customer postal code",
  customerTaxNum: "Customer tax number",
  customerTown: "Customer city",
  customRange: "Custom range",
  daily_closing: "Daily closing",
  date: "Date",
  datetime: "Date and time",
  day: "Day",
  day_must_be_open: "Open the days first for this action!",
  day1: "Sunday",
  day2: "Monday",
  day3: "Tuesday",
  day4: "Wednesday",
  day5: "Thursday",
  day6: "Friday",
  day7: "Saturday",
  days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
  daysAgo: "{0} days ago",
  deactivate: "Deactivate",
  default: "Default",
  default_cashregister_change: "<strong>{0}</strong> should be the default cash register on this machine?",
  default_language: "Default",
  default_production_line: "Default production line",
  default_store: "Default warehouse",
  default_takeaway_vat_category: "Takeaway VAT",
  default_vat_category: "VAT",
  delete: "Delete",
  delete_all_order_history: "Delete all order history",
  delete_order_history: "Delete all past orders",
  delete_traffic: "Delete traffic",
  deleted: "Deleted",
  deletion_not_allowed: "Deletion not possible",
  deliverable_tables: "Meals ready for tables",
  delivered_refresh_position: "Delivered with GPS update",
  delivery: "Delivery",
  delivery_addresses: "Address Count",
  delivery_avg_time: "Average Time",
  delivery_count: "Delivery Count",
  delivery_distance: "Distance (Km)",
  delivery_note_id: "Delivery note id",
  description: "Description",
  detailed: "Detailed bill",
  differences_in_active: "Difference in active status",
  differences_in_additions: "Difference in recipe options",
  differences_in_available: "Difference in orderability",
  differences_in_availableQuantities: "Difference in available quantities",
  differences_in_children: "Difference in children",
  differences_in_description: "Difference in description",
  differences_in_falatozz_availability: "Difference in Falatozz availability",
  differences_in_falatozz_price: "Difference in Falatozz price",
  differences_in_falatozzImage: "Difference in Falatozz image",
  differences_in_foodora_availability: "Difference in Foodora availability",
  differences_in_foodora_price: "Difference in Foodora price",
  differences_in_foodoraImage: "Difference in Foodora image",
  differences_in_foodpanda_availability: "Difference in Foodora availability",
  differences_in_foodpanda_price: "Difference in Foodpanda price",
  differences_in_image: "Difference in image",
  differences_in_included_options: "Difference in recipe (default included ingredients)",
  differences_in_inventory: "Difference in inventory item setting",
  differences_in_kiosk: "Különbség a kiosk státuszban",
  differences_in_labels: "Különbség a címkékben",
  differences_in_mandatory_options: "Difference in recipe (mandatory ingredients)",
  differences_in_manufacturer: "Difference in manufacturer",
  differences_in_name: "Difference in naming",
  differences_in_online: "Difference in webshop status",
  differences_in_optional_options: "Difference in optional options",
  differences_in_pos: "Difference in POS setting",
  differences_in_productionlines: "Difference in production lines",
  differences_in_quantitytype: "Difference in unit of measurement",
  differences_in_timing: "Difference in course",
  differences_in_top: "Difference in on menu status",
  differences_in_unitPrice: "Difference in unit price",
  differences_in_vat: "Difference in VAT",
  differences_in_wolt_availability: "Difference in Wolt availability",
  differences_in_wolt_price: "Difference in Wolt price",
  differences_in_woltImage: "Difference in Wolt image",
  disable_edit_mode: "Restore table layout",
  disconnected: "Not connected",
  discount: "Discount",
  discount_amount: "Fix amount",
  discount_percent: "Percent",
  discount_profit: "Profit",
  discount_types: "Discount types",
  discounts: "Discounts",
  disposed_quantity: "Disposed quantity",
  distance_to_big: "{0}km away from the address set for this location! Are you really at this address now? If so, shall we update the address GPS coordinates based on your current position?",
  do_you_really_delete_the_customer: "Do you really want to delete this customer?",
  do_you_really_want_to_delete_the_menu_category: "Are you sure you want to delete menu category?",
  do_you_really_want_to_delete_the_menu_item: "Are you sure you want to delete menu item?",
  do_you_really_want_to_print_only_the_selected_orders: "Do you really want to print only the selected order?",
  do_you_really_want_to_print_the_orders_until_timing: "Do you really want to print the orders only until <b>{0}</b> course?",
  do_you_really_want_to_reprint_only_the_selected_orders: "Do you really want to <b><u>reprint</u></b> the selected orders?",
  do_you_really_want_to_reprint_the_orders_until_timing: "Do you really want to <b><u>reprint</u></b> the orders until the <b>{0}</b>?",
  do_you_realy_want_to_order_so_many: "Do you really want to order <strong>{0}</strong> pieces?",
  do_you_want_to_catch_incoming_calls: "Would you like us to use call identification for incoming calls on this phone for home delivery/pickup data recording? If yes, please log in with the same user in the browser!",
  documentation: "Documentation",
  bad: "BAD",
  bad_entries: "Bad entries",
  good_entries: "Good entries",
  barcode_filter_all: "All",
  barcode_filter_central_status: "Central DB status",
  barcode_filter_entry_quality: "Entry quality",
  barcode_filter_synced_with_central: "Exists in global database (local = global)",
  barcode_filter_different_from_central: "Exists in global database (local != global)",
  barcode_sync_choose_image_title: "Choose image to keep",
  barcode_sync_choose_image_message: "Both local and global entries contain an image. Please choose which image should be kept for both.",
  barcode_sync_click_image_to_choose: "Click an image to choose it.",
  barcode_sync_hint_preferred: "Hint: preferred by score",
  barcode_sync_keep_local_image: "Keep local image",
  barcode_sync_keep_global_image: "Keep global image",
  barcode_sync_local_image: "Local image",
  barcode_sync_global_image: "Global image",
  bad_barcode_entries: "Bad barcode entries",
  doesnt_exists_in_central_database: "Does not exist in global database",
  dont_print: "Don't print",
  door: "Floor/door",
  download: "Download",
  download_barcodes: "Download",
  download_template: "Upload template",
  draft: "Draft",
  drink: "Drink",
  drink_available_quantity: "Available quantities",
  drink_category_editor: "Drink category editor",
  drink_category_name: "Category",
  drink_editor: "Drink editor",
  drink_name: "Name",
  drink_price: "Price",
  drink_quantity: "Quantity",
  drink_quantity_name: "Name",
  drink_quantity_type: "Quantity type",
  drinkbar: "Drinkbar",
  drinks: "Drinks",
  drop: "Drop",
  duplicate: "Duplicate",
  duration: "Duration",
  edit: "Edit",
  eggs: "eggs",
  email: "E-mail",
  email_pattern: "[^@]+@[^@]+(\\.[^@]+)+",
  empty: "Empty",
  "Enable Report Scheduling": "Enable Report Scheduling",
  enable_edit_mode: "Change table layout",
  "enabled-features": "Enabled features",
  end_count: "Real",
  enter_barion_pos_key: "Please provide your Barion Secret key (POSKey)",
  enter_category: "Enter category name",
  enter_cost: "Set cost",
  enter_description: "Enter description if needed",
  enter_Drink_menuitem: "Enter meal name",
  enter_invoice_heading: "Please provide the heading of the invoices in html format!",
  enter_labels: "Choose your labels",
  enter_Meal_menuitem: "Enter drink name",
  enter_percent: "Please enter the VAT value as percent (e.g. 27)",
  enter_phone_number: "Enter phone number",
  enter_price: "Set price: eg. 500 or 40%",
  new_price: "New price",
  change_order_items_state: "Change order item states",
  edit_order: "Edit order",
  enter_production_line_name: "Enter name for production line ",
  enter_table_number: "Enter table number",
  enter_table_seats: "Enter available seats",
  enter_vat_category_name: "Please enter the VAT category name",
  entities: "Entities",
  entity: "Entity",
  entity_type: "Entity type",
  entries: "Entries",
  entry: "Entry",
  entry_count: "Entry count",
  epd: "Table display",
  events: "Events",
  except: "Except",
  exchange_rate: "Exchange rate",
  exists_in_central_database: "Exists in global database",
  exit_rearrange_mode: "Exit rearrange mode",
  expiry_date: "Expiry",
  extend_occupation: "Extend the current occupation",
  extensions: "Extensions",
  "External HealthCheck: Successful": "Printer seems ok",
  extra_frame_bottom: "Bottom frame content",
  extra_frame_left: "Left frame content",
  extra_frame_right: "Right frame content",
  extra_frame_top: "Top frame content",
  failed_to_create_production_line_not_unique: "Failed to create production line! Not unique!",
  failed_to_create_table_not_unique: "Failed to create table. Table number is in use already!",
  failed_to_delete_discount_type_in_use: "Failed to delete the discount type! It is in use already. Deactivate it instead!",
  failed_to_delete_drink_category_in_use: "Failed to delete the drink category! It is in use already. Deactivate it instead!",
  failed_to_delete_drink_in_use: "Failed to delete the drink! It is in use already. Deactivate it instead!",
  failed_to_delete_label_in_use: "Failed to delete the label! It is in use already!",
  failed_to_delete_meal_category_in_use: "Failed to delete the meal category! It is in use already. Deactivate it instead!",
  failed_to_delete_meal_in_use: "Failed to delete the meal! It is in use already. Deactivate it instead!",
  failed_to_delete_production_line_in_use: "Failed to delete the production line! It is in use already. Deactivate it instead!",
  failed_to_delete_table_in_use: "The table cannot be deleted! It was already used! Deactivate it instead!",
  failed_to_delete_user: "Deletion failed. <br>Error: {0}",
  failed_to_delete_user_anonimize: "The user cannnot be deleted! Would you like to anonimize instead? Name, email, password will be deleted!",
  failed_to_execute_action: "Action failed!",
  failed_to_get_restaurant_layout: "No restaurant layout defined! Please upload one first!",
  failed_to_print_invoice: "Failed to print invoice!",
  failed_to_print_kitchen_slip: "Failed to print kitchen slip!",
  failed_to_send_order: "Failed to order: {0}",
  feedback: "Feedback",
  feedbacks: "Feedbacks",
  final_stock: "End stock",
  finalCost: "End cost",
  finalPrice: "End price",
  first_modify_start_date: "First change the start time",
  fiscal_receipt_already_printed: "This fiscal receipt has already been printed (receipt no.: {0})",
  fiscat_service_fee: "Service fee",
  fish: "fish",
  fix_quantity: "Fix quantity",
  floorplans: "Floorplans",
  food: "Food",
  for_all: "Apply for all",
  for_selected_none: "Apply for selected",
  for_selected_order: "Apply for selected order",
  for_selected_tableMate: "Apply for selected person",
  for_store: "For warehouse",
  format: "Format",
  free_seats: "Free seats",
  from_store: "Source warehouse",
  fromDate: "From date",
  fromTime: "From time",
  full_inventory: "Full inventory",
  partial_inventory: "Partial inventory",
  generate_access_token: "Generate access token",
  getting_location: "Determining your current location...",
  global_id: "Global id",
  global_value: "Global value",
  gluten: "gluten",
  Grid: {
    Pager: {
      Button: {
        backButtonText: "Back",
        nextButtonText: "Next"
      },
      Description: {
        no_records: "No %{recordType} Available",
        records_displayed: "%{firstIndex} through %{lastIndex} of %{total} %{recordType} Displayed"
      }
    }
  },
  gross_weight: "Gross weight",
  hellopay: {
    error: {
      "1": "Unknown or other error",
      "10": "User is in the menu",
      "11": "Failed external_identifier validation",
      "12": "Failed transaction loading",
      "13": "Insufficient permissions",
      "14": "Terminal is not in the correct state (controlled by OTP/Unipass)",
      "2": "Timeout or interruption, card not found",
      "3": "Invalid or faulty card",
      "4": "Insufficient balance on the card",
      "5": "Wrong card inserted",
      "6": "Non-reversible because it's not the last transaction",
      "7": "Not a HelloPay card",
      "8": "Card communication error",
      "9": "Tablet communication error"
    }
  },
  history: "History",
  homedelivery: "Home delivery",
  hospitalityUnit: "Hospitality Unit",
  hour: "Hour",
  how_much: "How much",
  id: "Id",
  if: "Condition",
  image: "Image",
  included: "Removable",
  included_receipe: "Ingredients that are included in the product but can be removed or substituted when ordering. For example, in a cappuccino, milk can be replaced with lactose-free milk.",
  included_recipe: "Ingredients that are included in the product but can be removed or substituted when ordering. For example, in a cappuccino, milk can be replaced with lactose-free milk.",
  income: "Income",
  income_without_cost: "Income without cost?",
  incoming_stock: "Incoming",
  incoming_stock_entry_text_input: "Text input",
  incomingStock: "Incoming stock",
  incomingStocks: "Incoming stocks",
  inDays: "In {0} days",
  inherit: "Inherit",
  initial_stock: "Starting stock",
  initialCost: "Starting cost",
  initialPrice: "Starting price",
  inMonths: "In {0} months",
  input_stores: "Input warehouses",
  install_printer_server: "Installation of printer server",
  installments_strategy: "Payment schedule",
  "Internal HealthCheck: Successful": "Printer seems ok",
  inventory: "Stock-taking",
  inventory_disposal: "Disposal",
  inventory_shortage: "Shortage",
  inventory_surplus: "Surplus",
  invoice: "Invoice",
  invoice_logo: "Invoice logo",
  invoice_logo_padding: "Invoice logo padding",
  choose_image: "Choose image",
  use_restaurant_logo: "Use restaurant logo",
  no_image_selected: "No image selected",
  logo_padding_helper_hint: "The checkerboard background makes the added white side margins visible.",
  logo_width_ratio: "Logo width ratio",
  monochrome_threshold: "Monochrome threshold",
  threshold_description: "Pixels darker than this value become black; lighter pixels become white.",
  invoice_count: "Original quantity",
  invoice_footer: "Invoice footer",
  invoice_heading: "Invoice heading",
  invoice_id: "Invoice number",
  invoice_not_found: "Invoice number not found in the online számla system",
  invoice_printed: "Invoice successfully sent to printer",
  inYears: "In {0} years",
  is_paid: "Paid",
  isInventoryItem: "Inventory item",
  isInventoryItem2: "Inventory item/Raw material",
  isInventoryItem3: "Inventory item",
  isPos: "POS",
  isTop: "Main product",
  item: "Item",
  joins: "Joins",
  joins_table: "Joins the {0}th occupation with {1} people",
  joins_table1: "Joins the first occupation with {0} people",
  kiosk: "Kiosk",
  kioskOrder: "Kiosk order",
  kiosk_cash_slip_header: "CASH PAYMENT RECEIPT",
  kiosk_pay_at_cashier: "Please pay at the cashier!",
  kiosk_order_not_finalized: "Your order is not yet paid!",
  kiosk_go_to_table_to_pay: "Please pay here: {0}!",
  label: "Label",
  label_count: "Label count",
  label_printer: "Label printer",
  labels: "Labels",
  language: "Language",
  languages: "Languages",
  last_3_months: "Last 3 months",
  last_30_days: "Last 30 days",
  last_7_days: "Last 7 days",
  last_month: "Previous month",
  last_quarter: "Previous quarter",
  last_status: "Last status",
  last_week: "Previous weeek",
  lastBuy: "Last Purchase",
  lastInventory: "Last Inventory",
  lastSale: "Last Usage",
  latitude: "Latitude",
  layout_succesfully_saved: "Table layout saved!",
  linked_product: "Linked own product",
  list: "List",
  local_addition_tooltip: "Applied for local consumption",
  local_consumption: "Local consumption",
  local_product: "Linked product",
  local_url: "LAN url",
  local_value: "Local value",
  localConsumption: "Local consumption",
  lock: "Occupy",
  lock_homedelivery: "New home delivery",
  lock_pickup: "New pickup",
  locked: "locked",
  longitude: "Longitude",
  lupin: "lupin",
  make_bookOnline: "Enable guest occupation",
  make_kiosk: "It is kiosk",
  make_non_kiosk: "It is not kiosk",
  make_non_pos: "It is not a point of sale",
  make_nonBookOnline: "Disable guest occupation",
  make_nonVisibleOnline: "Hide table from guests",
  make_pos: "It is point of sale",
  make_shareable: "Make table shareable",
  make_unshareable: "Make table non-shareable",
  make_visibleOnline: "Make table visible to guests",
  mandatory: "Mandatory",
  mandatory_radio_option: "One options will have to selected from the category when ordering",
  mandatory_receipe: "Ingredients that the product must contain. For example, in the case of pizza, the pizza base.",
  manual: "Manual",
  manualOnly: "Manual",
  manufacturer: "Manufacturer",
  map: "Map",
  mate_already_joined_table_in_this_restaurant: "{0} already joined table no. {1}!",
  maxPrice: "Maximum price",
  maxStock: "Maximum stock",
  meal: "Meal",
  meal_available_quantity: "Available quantities",
  meal_category_editor: "Meal category editor",
  meal_category_name: "Category",
  meal_editor: "Meal editor",
  meal_name: "Name",
  meal_price: "Price",
  meal_quantity: "Quantity",
  meal_quantity_name: "Name",
  meal_quantity_type: "Quantity type",
  meal_timing: "Timing",
  meals: "Meals",
  menu: "Menu",
  menuitem: "Item",
  menuitem_ordered: "What",
  menuitems: {
    _complex_product: "not sold complex product",
    _complex_product_ingredient: "not sold complex product sub-product",
    _complex_product_ingredient_option: "not sold complex product sub-product and option",
    _complex_product_option: "not sold complex product and option",
    _inventory: "not sold stocked unused ingredient",
    _inventory_ingredient: "not sold stocked ingredient",
    _inventory_ingredient_option: "not sold stocked ingredient and option",
    _inventory_option: "not sold stocked option",
    _linked_product: "not sold referenced product",
    _linked_product_ingredient: "not sold referenced product sub-product",
    _linked_product_ingredient_option: "not sold referenced product sub-product and option",
    _linked_product_option: "not sold referenced product and option",
    _service: "not sold service",
    _service_ingredient: "not sold service sub-product",
    _service_ingredient_option: "not sold service sub-product and option",
    _service_option: "not sold service option",
    sold_complex_product: "sold complex product",
    sold_complex_product_ingredient: "sold complex sub-product",
    sold_complex_product_ingredient_option: "sold complex sub-product and option",
    sold_complex_product_option: "sold complex product and option",
    sold_inventory: "sold stocked product",
    sold_inventory_ingredient: "sold stocked product ingredient",
    sold_inventory_ingredient_option: "sold stocked product ingredient option",
    sold_inventory_option: "sold stocked product option",
    sold_linked_product: "sold linked product",
    sold_linked_product_ingredient: "sold referenced stocked product ingredient",
    sold_linked_product_ingredient_option: "sold referenced stocked product ingredient option",
    sold_service: "sold service",
    sold_service_ingredient: "sold service sub-product",
    sold_service_ingredient_option: "sold service sub-product and option",
    sold_service_option: "sold service option",
    tooltip: {
      _complex_product: "Not directly sold complex product, which consists of other products",
      _complex_product_ingredient: "Not directly sold complex product, which consists of other products, and is referenced by another product in its recipe",
      _complex_product_ingredient_option: "Not directly sold complex product, which consists of other products, and is referenced by another product in its recipe as well as an option",
      _complex_product_option: "Not directly sold complex product, which consists of other products, as well as an option for another product",
      _inventory: "Stocked ingredient not used/referenced by other products",
      _inventory_ingredient: "Not directly sold stocked ingredient, which is referenced by another product in its recipe",
      _inventory_ingredient_option: "Not directly sold stocked ingredient, which is referenced by another product in its recipe as well as an option",
      _inventory_option: "Not directly sold stocked ingredient, which is referenced by another product as an option",
      _linked_product: "Not directly sold referenced (priced differently, special quantity, or just a copy of another product) product",
      _linked_product_ingredient: "Not directly sold referenced (priced differently, special quantity, or just a copy of another product) product, and is included in another product's recipe",
      _linked_product_ingredient_option: "Not directly sold referenced (priced differently, special quantity, or just a copy of another product) product, and is referenced by another product in its recipe as well as an option",
      _linked_product_option: "Not directly sold referenced (priced differently, special quantity, or just a copy of another product) product, as well as an option for another product",
      _service: "Not sold service, which is not referenced by any other product as a recipe or option",
      _service_ingredient: "Not directly sold service, which is referenced by another product in its recipe",
      _service_ingredient_option: "Not directly sold service, which is referenced by another product in its recipe as well as an option",
      _service_option: "Not directly sold service, which is referenced by another product as an option",
      active: "Active product",
      available_online: "Product available for order online",
      deactivated: "Deactivated product",
      def_is_inventory_item: "Default but cannot be selected as a packaging option during sale. This is not good. Select a default sellable packaging! This unit is the basis for inventory management. It can be received and inventoried in this unit.",
      def_non_inventory_item: "Default but cannot be selected as a packaging option during sale. This is not good. Select a default sellable packaging! Normal product quantity. Not an inventory unit.",
      def_on_menu_is_inventory_item: "Default and can be selected as a packaging option during sale. This unit is the basis for inventory management. It can be received and inventoried in this unit.",
      def_on_menu_non_inventory_item: "Default and can be selected as a packaging option during sale. Normal product quantity. Not an inventory unit.",
      default_inventory_item: "Inventory-managed product (raw material). Inherits this property from its category.",
      default_not_inventory_item: "Non-inventory-managed product. Inherits this property from its category.",
      expected_profit: "Expected profit ratio",
      free_quantity: "During ordering, the sold quantity can be freely modified (e.g., necessary for weighing goods).",
      inventory_item: "Inventory-managed product (raw material)",
      is_inventory_item: "Cannot be selected as a packaging option during sale. This unit is the basis for inventory management. It can be received and inventoried in this unit.",
      no_inventory_quantity_selected: "The product is a stocked inventory item, but no inventory quantity is selected.",
      non_inventory_item: "Cannot be selected as a packaging option during sale. Normal product quantity. Not an inventory unit.",
      not_available_online: "Product currently not available for order online",
      not_free_quantity: "During ordering, only predefined packaging options (quantities) can be selected.",
      not_inventory_item: "Non-inventory-managed product (raw material)",
      not_on_kiosk: "Not available on kiosk",
      not_on_menu: "Not a main product, not directly orderable, only as an option for other products",
      not_online: "Product not visible in the online store",
      not_pos: "Cannot be ordered on-site by waiter or seller",
      on_kiosk: "Available on kiosk",
      on_menu: "Main product, directly orderable",
      on_menu_is_inventory_item: "Can be selected as a packaging option during sale. This unit is the basis for inventory management. It can be received and inventoried in this unit.",
      on_menu_non_inventory_item: "Can be selected as a packaging option during sale. Normal product quantity. Not an inventory unit.",
      online: "Product visible in the online store",
      pos: "Can be ordered on-site by waiter or seller",
      profit_ratio: "Profit margin",
      sold_complex_product: "sold complex product, which consists of other products",
      sold_complex_product_ingredient: "complex subproduct sold, composed of other productsl",
      sold_complex_product_option: "sold complex product, which consists of other products, as well as an option for another product",
      sold_inventory: "Sold inventory-managed finished product, meaning the sold product is also an inventoried raw material.",
      sold_inventory_ingredient: "Sold inventory-managed finished product, meaning the sold product is also an inventoried raw material and ingredient of another product.",
      sold_inventory_ingredient_option: "Sold inventory-managed finished product, meaning the sold product is also an inventoried raw material and ingredient of another product, as well as an option.",
      sold_inventory_option: "Sold inventory-managed finished product, meaning the sold product is also an inventoried raw material and option of another product.",
      sold_linked_product: "sold linked product",
      sold_linked_product_ingredient: "sold linked product, ingredient",
      sold_linked_product_ingredient_option: "sold referenced product, subproduct, options, i.e., it only refers to one product",
      sold_linked_product_option: "sold referenced product, options, i.e., it only refers to one product",
      sold_service: "Sold service, where the product is not inventoried (not a raw material) and does not contain other products (empty recipe), making it a service.",
      sold_service_ingredient: "Sold service sub-product, where the product is not inventoried (not a raw material) and does not contain other products (empty recipe), making it a service, but it is referenced in the recipe of another product.",
      sold_service_ingredient_option: "sold service ingredient option, meaning the product itself is not stocked (not an ingredient) and does not contain any other products (empty recipe), so it is a service, and other products reference it in their recipe as well as an option",
      sold_service_option: "sold service option, meaning the product itself is not stocked (not an ingredient) and does not contain any other products (empty recipe), so it is a service, which is referenced by other products as an option",
      suggested_price: "Suggested price",
      to_many_inventory_quantity_selected: "The product has multiple inventory quantities, so the system cannot determine which one to reduce inventory from. Please select only one inventory quantity.",
      unit_cost: "Net purchase price",
      unit_price: "Selling price for one unit for local consumption"
    }
  },
  menu_change_log_history: "History",
  chatgpt_open: "Open ChatGPT in a floating window",
  voice_order_open: "Order by voice",
  voice_order_title: "Voice order",
  voice_order_close: "Close",
  voice_order_start: "Turn the microphone on",
  voice_order_stop: "Turn the microphone off",
  voice_order_connecting: "Connecting...",
  voice_order_stopped: "Microphone is off",
  voice_order_listening: "Listening, say what the guests want",
  voice_order_thinking: "Thinking...",
  voice_order_speaking: "Speaking...",
  voice_order_empty: "The list is empty.",
  voice_order_comment: "Comment",
  voice_order_remove: "Remove",
  voice_order_clear: "Clear",
  voice_order_add: "Add to table order",
  voice_order_not_configured: "Voice ordering is not set up on the server.",
  voice_order_session_failed: "Could not start the voice assistant. Try again in a moment.",
  voice_order_mic: "The microphone is not available. Allow microphone access for this app.",
  voice_order_connection: "The voice connection was lost.",
  voice_order_no_table: "Select a table first, then add the list to its order.",
  voice_order_incomplete: "Not everything was ordered. The rest stays on the list.",
  voice_action_confirm: "Confirm",
  voice_order_lock_failed: "The table could not be opened. Open it on the screen first.",
  voice_order_print_failed: "The items were added but could not be submitted and printed. Use Order and print.",
  voice_action_dismiss: "Dismiss",
  voice_action_done: "Done",
  voice_action_failed: "It did not work",
  voice_move_confirm: "Move %{from} to %{to}?",
  voice_join_confirm: "Move %{from} to %{to} and merge it with the guests there?",
  voice_new_confirm: "Seat %{from} at the shared table %{to} as a separate party?",
  voice_extend_confirm: "Extend %{from} with the shared table %{to}?",
  voice_add_table_confirm: "Add %{to} to %{from}?",
  voice_remove_orders_confirm: "Delete the order: %{items}?",
  voice_unlock_confirm: "Close %{table}?",
  voice_unlock_confirm_cancel: "Close %{table} and cancel its %{count} unpaid order(s)?",
  chatgpt_prompt_plugin: "First check whether the EatWithMe plugin is installed. If it is not installed, install it with this link: %{link}.",
  chatgpt_prompt: 'Set the working restaurant to "%{name}" (restaurantId %{id}). Use this restaurantId in every EatWithMe tool call from now on and do not ask which restaurant to use.',
  chatgpt_prompt_instance: 'Set the working restaurant to "%{name}" (restaurantId %{id}, instance %{instance}). Use this restaurantId and instance in every EatWithMe tool call from now on and do not ask which restaurant to use.',
  menu_change_log: {
    title: "Menu change log",
    history: "History",
    time_from: "From",
    time_to: "To",
    modifier: "Modified by",
    all_modifiers: "Everyone",
    entity_type: "Entity type",
    all_entity_types: "All",
    type_item: "All products",
    type_category: "All categories",
    Meal: "Meal",
    Drink: "Drink",
    MealCategory: "Meal category",
    DrinkCategory: "Drink category",
    QuantityType: "Serving",
    modification_type: "Modification type",
    all_modification_types: "All",
    CREATE: "Created",
    UPDATE: "Modified",
    DELETE: "Deleted",
    RESTORE: "Restored",
    ACTIVATE: "Activated",
    DEACTIVATE: "Deactivated",
    MOVE: "Moved",
    REORDER: "Reordered",
    source_ADMIN: "Admin",
    source_MCP: "ChatGPT",
    text: "Name contains",
    search: "Search",
    reset: "Reset",
    time: "Time",
    entity: "Entity",
    source: "Source",
    changes: "Changes",
    field: "Field",
    old_value: "Old value",
    new_value: "New value",
    no_results: "No changes found.",
    no_details: "No details.",
    total: "Total",
    previous: "Previous",
    next: "Next",
    load_failed: "The change log could not be loaded.",
    yes: "Yes",
    no: "No",
    on: "on",
    off: "off",
    quantity: "quantity",
    item_addition: "product addition",
    category_addition: "category addition",
    more: "more",
    chatgpt_bubble_title: "Changes made by ChatGPT"
  },
  menu_change_log_fields: {
    name: "Name",
    shortName: "Short name",
    description: "Description",
    active: "Active",
    available: "Available",
    pos: "POS",
    kiosk: "Kiosk",
    online: "Online",
    top: "Top",
    order: "Order",
    timing: "Timing",
    fromDate: "Available from",
    toDate: "Available until",
    recordState: "Record state",
    color: "Color",
    manufacturer: "Manufacturer",
    mainCategory: "Main category",
    subCategory: "Subcategory",
    allergens: "Allergens",
    freeQuantity: "Free quantity",
    inventoryItem: "Inventory item",
    pricePerCostRatio: "Price / cost ratio",
    priceCalculator: "Price calculator",
    categoryId: "Category",
    parentCategoryId: "Parent category",
    vatCategoryId: "VAT category",
    takeawayVatCategoryId: "Takeaway VAT category",
    productionLineIds: "Production lines",
    labels: "Labels",
    quantity: "Quantity",
    price: "Price",
    cost: "Cost",
    def: "Default",
    default: "Default",
    onMenu: "On menu",
    quantityTypeId: "Quantity type",
    quantityType: "Quantity type",
    containerCharge: "Container charge",
    containerChargeOnsite: "Container charge on site",
    labelCount: "Label count",
    promotionStart: "Promotion start",
    promotionEnd: "Promotion end",
    promotionName: "Promotion name",
    promotionPrice: "Promotion price",
    settings: "Settings",
    additionType: "Addition type",
    optionType: "Option type",
    min: "Minimum",
    max: "Maximum",
    proportional: "Proportional",
    image: "Image",
    bigImage: "Large image"
  },
  menus: {
    menuChangeLog: "Menu change log",
    administration: "Administration",
    advertisements: "Advertisements",
    analytics: "Analytics",
    bankTerminal: "Bank terminal",
    bankTerminals: "Bank terminals",
    bar: "Bar",
    barcodes: "Barcodes",
    bi: "Business intelligence",
    cashRegisters: "Cash registers",
    check_subscriptions: "Check subscriptions",
    comments: "Comments",
    customers: "Customers",
    currencies: "Currencies",
    daily_closing: "Daily closing",
    discounts: "Discounts",
    drinks: "Drinks",
    falatozz: "Falatozz",
    falatozz_administration: "Falatozz adminisztráció",
    foodora_administration: "Foodora adminisztráció",
    foodpanda: "FoodPanda",
    guestScreen: "Guest screen",
    incomingStocks: "Incoming stocks",
    inventory: "Inventory",
    inventoryScrapping: "Inventory scrapping",
    kiosks: "Kiosks",
    labels: "Lables",
    pricetags: "Price tags",
    manage_reports: "Manage reports",
    mautic: "CRM",
    meals: "Meals",
    menuitems: "Products",
    monitoring: "Monitoring",
    opening_hours: "Opening hours",
    orders: "Orders",
    orders_quick_action: "Set order status",
    paymentMethods: "Payment methods",
    plans: "Plans",
    pointOfSales: "Point of sales",
    printers: "Printers",
    productionLines: "Production lines",
    products: "Products",
    profile: "My profile",
    rbac: "Access roles",
    reports: "Reports",
    restaurants: "Restaurants",
    scales: "Scales",
    send_reseller_fees: "Send resellers fees",
    send_reseller_fees_to_me: "Send resellers fee to me only",
    serving: "Serving",
    servings: "Servings",
    shoppingList: "Shopping list",
    stockList: "Stock management",
    stockManagement: "Stock management",
    stockMovements: "Stock movements",
    stockReport: "Stock statistics",
    stores: "Warehouses",
    superAdminMenu: "Super admin",
    suppliers: "Suppliers",
    support: "Support",
    tableBooking: "Table reservations",
    tableOverview: "Table overview",
    tables: "Tables",
    todaytraffic: "Daily traffic",
    traffic: "Traffic",
    updateSettings: "Updates",
    users: "Users",
    VATCategories: "VAT categories",
    voipphone: "VOIP Phone",
    waiterScreen: "Waiter screen",
    wolt: "Wolt",
    wolt_administration: "Wolt administration",
    choiceqr: "ChoiceQR",
    choiceqr_administration: "ChoiceQR administration",
    guidelines_whats_new: "Guidelines & What's new",
    video_guides: "Video guide",
    chat_with_support: "Chat with support"
  },
  milk: "milk",
  minimum_price: "The final price cannot be less than the base price, even if default options are turned off at the time of ordering. For example, with pizzas, even if a topping is removed, the pizza should not become cheaper.",
  minimumStock: "Minimum quantity when we typically restock",
  minPrice: "Minimum price",
  minStock: "Minimum stock",
  minute: "minute",
  minutes: "minutes",
  modified_by: "Modified",
  mollusks: "mollusks",
  month: "Month",
  monthsAgo: "{0} months ago",
  more_addresses: "Other addresses",
  more_than_a_day: "> 1 day",
  kitchen_total_time: "Total",
  move_back: "Move to back",
  move_backward: "Move backward",
  move_forward: "Move forward",
  move_top: "Move on top",
  moved_quantity: "Transfered quantity",
  multiple_inventory_quantity_selected: "Do you really want to set multiple individual inventory quantities!",
  multiple_physical_printers_try_to_server_the_virtual_server: "Multiple physical printers are configured for virtual printer {0}! The '{1}' and the '{2}'!",
  multiplicator: "Multiplicator",
  mustard: "mustard",
  myOrders: "My order",
  mode: "Mode",
  templates: "Templates",
  select: "Select",
  save_as_template: "Save as template",
  template_name: "Template name",
  template_name_required: "Template name is required.",
  fill_out_guide: "Fill-out guide",
  inventory_excel_menu_item_id: "Menu item ID",
  inventory_excel_menu_item_global_id: "Menu item global ID",
  inventory_excel_inventory_quantity: "Inventory quantity",
  inventory_excel_count: "Count",
  inventory_excel_guide_no_unit: "If no unit is written, the value is interpreted as count × quantity × quantity_type. Example: quantity=1000, quantity_type=g, count=2 means 2 × 1000g = 2000g.",
  inventory_excel_guide_editable_column: "Only the \"{0}\" column is editable.",
  inventory_excel_guide_units: "You can enter values like 10l, 10dl, 10g, 10kg, 10pcs. The system converts them automatically.",
  invalid_inventory_count: "Use a number or a number with the matching unit for this item.",
  inventory_excel_guide_interpretation: "Count is interpreted in this row's inventory unit: {0} + {1}.",
  inventory_excel_guide_empty_skipped: "If count is empty, the row is skipped during import.",
  no_traffic_items_message: "The following items have no recent activity and will be excluded from this inventory: {0}{1}",
  exclude_no_traffic_items: "Exclude items",
  keep_no_traffic_items: "Keep items",
  no_entries_can_be_added_for_selected_store: "No entries can be added for the selected store.",
  search: "Search",
  guidelines_whats_new_intro: "Role-based updates and operational guidelines for your account.",
  video_guides_intro: "Short videos showing how to do the most common tasks.",
  video_guides_search_placeholder: "Search title, summary or tags",
  video_guides_empty: "No video guides match your search.",
  video_guides_coming_soon: "Video coming soon",
  video_guides_play: "Play video",
  video_guides_large_player: "Large player (HD)",
  video_guides_open_youtube: "Open on YouTube",
  video_guides_close: "Close",
  video_guides_recorded_with: "Playwright script",
  video_guides_show_script: "Show script",
  video_guides_hide_script: "Hide script",
  video_guides_script_missing: "The script is not exported yet. Run: npm run video:export",
  guidelines_whats_new_search_label: "Search",
  guidelines_whats_new_search_placeholder: "Search title, summary, details or tags",
  guidelines_whats_new_filter_type_all: "All types",
  guidelines_whats_new_filter_freshness_all: "All updates",
  guidelines_whats_new_date_range_label: "Date range",
  guidelines_whats_new_filter_module_all: "All tags",
  guidelines_whats_new_filter_module_placeholder: "Select tags",
  guidelines_whats_new_date_range_all_time: "All time",
  guidelines_whats_new_date_range_1day: "Modified since 1 day",
  guidelines_whats_new_date_range_1week: "Modified since 1 week",
  guidelines_whats_new_date_range_1month: "Modified since 1 month",
  guidelines_whats_new_date_range_2months: "Modified since 2 months",
  guidelines_whats_new_date_range_3months: "Modified since 3 months",
  guidelines_whats_new_date_range_1year: "Modified since 1 year",
  guidelines_whats_new_structure_title: "Grouped by tags",
  guidelines_whats_new_journey_orders: "Orders and service",
  guidelines_whats_new_journey_kitchen_delivery: "Kitchen and delivery",
  guidelines_whats_new_journey_inventory_admin: "Inventory and administration",
  guidelines_whats_new_journey_administration: "Administration",
  guidelines_whats_new_journey_insights: "Reports and insights",
  guidelines_whats_new_module_sales: "Sales",
  guidelines_whats_new_module_kitchen: "Kitchen",
  guidelines_whats_new_module_stockmanagement: "Stock management",
  guidelines_whats_new_module_reports: "Reports",
  guidelines_whats_new_module_administration: "Administration",
  guidelines_whats_new_module_integrations: "Integrations",
  guidelines_whats_new_type_guideline: "Modified",
  guidelines_whats_new_type_whats_new: "New",
  guidelines_whats_new_freshness_new: "New",
  guidelines_whats_new_freshness_changed: "Modified",
  guidelines_whats_new_freshness_stable: "Stable",
  guidelines_whats_new_created_at: "Created",
  guidelines_whats_new_modified_at: "Modified",
  guidelines_whats_new_reset_filters: "Reset",
  guidelines_whats_new_results: "Results",
  guidelines_whats_new_empty: "No updates available for your current role.",
  name: "Name",
  not_logged_in_yet: "Not logged in yet",
  superadmin: {
    add_user: "Add User",
    edit_user: "Edit User",
    activate_user: "Activate User",
    deactivate_user: "Deactivate User",
    add_role: "Add Role",
    delete: "Delete",
    sync_to_mautic: "Sync to Mautic",
    user: "User",
    online: "Online",
    active: "Active",
    role: "Role",
    entity_type: "Entity Type",
    entity: "Entity",
    filter_by_name: "Filter by name...",
    filter_by_entity: "Filter by entity...",
    all: "All",
    offline: "Offline",
    deactivated: "Deactivated",
    default: "Default",
    admin: "Admin",
    printer_server: "Printer Server",
    user_replication: "User Replication",
    tester: "Tester",
    waiter: "Waiter",
    finance: "Finance",
    inventory: "Inventory",
    courier: "Courier",
    restaurant: "Restaurant",
    store: "Store",
    none: "None",
    loading: "Loading...",
    no_users_found: "No users found",
    yes: "Yes",
    no: "No",
    show: "Show",
    entries: "entries",
    showing: "Showing",
    to: "to",
    of: "of",
    previous: "Previous",
    next: "Next",
    user_editor: "User Editor",
    add_user_title: "Add User",
    edit_user_title: "Edit User",
    name: "Name",
    surname: "Surname",
    email: "Email",
    password: "Password",
    gitlab_secure_token: "GitLab Secure Token",
    close: "Close",
    save: "Save",
    role_editor: "Role Editor",
    users: "Users",
    entities: "Entities",
    confirmation: "Confirmation",
    delete_user_confirm: "Are you sure you want to delete user {0}?"
  },
  name_of_customer: "Set name of guest",
  net_price: "Net price",
  net_unit_price: "Net unit price",
  netto_income: "Net income",
  new: "new",
  new_in_central_database: "Available from global database",
  new_independent_occupation: "New occupation",
  new_lock: "+ Occupy",
  new_occupation: "As new occupation",
  new_order: "New order",
  new_position: "No GPS coordinates were set for this address. Do you want to set it to your current location?",
  new_sale: "New sale",
  next: "Next",
  nextInventory: "Next Planned Inventory",
  no: "No",
  "No connection with the guest display": "No connection with the guest display",
  "No tip": "No tip",
  no_bluetooth_adapter: "Bluetooth iterface is not available!",
  no_bluetooth_cashiers: "Please connect or pair a bluetooth cashier machine!",
  no_inventory_quantity: "No quantity was selected for inventory handling!",
  no_inventory_quantity_selected: "Inventory item but no inventory quantity is selected!",
  no_matches_found: "No match found",
  no_permission_to_perform_this_action: "You do not have permission to perform this operation.",
  no_restaurants_found: "No restaurants found",
  no_serial_cashiers: "Please connect a cashier machine with usb-serial cable!",
  non_printer_configured: "No printer configured",
  not_allowed_order_is_being_paid: "Action not allowed with an order being paid!",
  not_allowed_order_paid: "Action not allowed with a paid order!",
  not_defined: "???",
  not_empty_pattern: "\\w+",
  not_selected: "Not selected",
  not_used_ingredient: "Not used ingredient",
  ntak: {
    _default_ntak_main_category: "Main category",
    _default_ntak_sub_category: "Subcategory",
    categories: "NTAK",
    cert: "Certificate (CER)",
    cert_request: "Certificate request (CSR)",
    cert_request_download: "Download certificate request",
    cert_request_generate: "Generate new certificate request",
    cert_upload: "Upload certificate",
    default_ntak_main_category: "NTAK Main category",
    default_ntak_sub_category: "NTAK Subcategory",
    key: "Private key (KEY)",
    key_upload: "Upload private key",
    main_categories: [{ "id": 5, "name": "Food", "shortName": "Food", "sub_categories": [{ "id": 1, "name": "Breakfast" }, { "id": 2, "name": "Sandwich" }, { "id": 3, "name": "Appetizer" }, { "id": 4, "name": "Soup" }, { "id": 5, "name": "Main course" }, { "id": 6, "name": "Side dish" }, { "id": 7, "name": "Pickles/salad", "shortName": "Pickles/Salad" }, { "id": 8, "name": "Dessert" }, { "id": 9, "name": "Snack" }, { "id": 30, "name": "Main course with side dish" }, { "id": 31, "name": "Food package" }, { "id": 10, "name": "Other" }] }, { "id": 1, "name": "Locally made non-alcoholic beverage", "shortName": "Loc. bev.", "sub_categories": [{ "id": 11, "name": "Lemonade/syrup/freshly squeezed drink", "shortName": "Lem/Syr/Fresh" }, { "id": 12, "name": "Non-alcoholic cocktail", "shortName": "Non-alc. cocktail" }, { "id": 13, "name": "Tea/hot chocolate" }, { "id": 14, "name": "Coffee" }, { "id": 32, "name": "Beverage package" }] }, { "id": 2, "name": "Non-locally made non-alcoholic beverage", "shortName": "Non-loc. bev.", "sub_categories": [{ "id": 15, "name": "Water" }, { "id": 16, "name": "Carbonated soft drink" }, { "id": 17, "name": "Non-carbonated soft drink" }, { "id": 33, "name": "Non-carbonated soft drink" }, { "id": 32, "name": "Beverage package" }] }, { "id": 3, "name": "Alcoholic beverage", "shortName": "Alc. bev.", "sub_categories": [{ "id": 18, "name": "Cocktail" }, { "id": 19, "name": "Liqueur" }, { "id": 20, "name": "Spirit" }, { "id": 21, "name": "Beer" }, { "id": 22, "name": "Wine" }, { "id": 23, "name": "Champagne" }, { "id": 32, "name": "Beverage package" }] }, { "id": 4, "name": "Other", "shortName": "Other", "sub_categories": [{ "id": 10, "name": "Other" }, { "id": 26, "name": "Delivery fee" }, { "id": 27, "name": "Environmentally friendly packaging", "shortName": "Eco. pack." }, { "id": 28, "name": "Plastic packaging", "shortName": "Plas. pack." }, { "id": 29, "name": "Discount" }, { "id": 34, "name": "Non-catering" }] }],
    mainCategoryNotSet: "The NTAK main category is not set for any product! It can be set at the category level (it will be inherited) or at the product level.",
    ntak: "NTAK",
    ntak_id: "NTAK ID",
    save_ntak_id: "Save NTAK ID",
    status: "NTAK status",
    status_error: "NTAK error",
    subCategoryNotSet: "The NTAK sub category is not set for any product! It can be set at the category level (it will be inherited) or at the product level.",
    taxid: "Tax ID",
    test: "Test connection"
  },
  number_of_persons: "Number of persons",
  number_of_seats: "Seats available",
  nuts: "nuts",
  occupy: "Occupy",
  ok: "Ok",
  oldest_order: "Latest order: {0}",
  on_day: "On day of week",
  online: "Webshop",
  online_szamla_feature: "Online Invoice module is currently not activated in your subscription. The module can download VAT invoices received in the Online Invoice system and automatically/semi-automatically record them as needed.",
  onsite: "Local consumption",
  open: "Open",
  open_day: "Open day",
  opened: "Open",
  opening_time: "Opening time",
  option: "Option",
  optional: "Options",
  optional_radio_option: "Maximum one options can be selected from the category when ordering",
  reduce_optional_options: "Reduce selectable options from this category",
  reduce_optional_options_description: "By default all items from the referenced category are offered as options. Uncheck specific items here to restrict the selection to only the checked ones. If all items remain checked, no restriction applies and the full category is offered.",
  optional_receipe: "Additional options that can either enhance the product or replace a default ingredient when ordering.",
  optional_recipe: "Additional options that can either enhance the product or replace a default ingredient when ordering.",
  order_cannot_be_deleted_while_mate_is_paying: "Orders of a person in process of payment cannot be deleted!<br/>Remove first the payment state of the person!",
  order_cannot_be_deleted_while_order_was_already_selected_for_payment_one: "Orders selected once for payment can be deleted only with administrator rights!",
  order_fee: "System usage fee",
  order_no: "Order no.",
  order_number: "Order number: {0}",
  order_sequence_number: "Order number",
  order_summary: "Order summary",
  ordered_by: "Ordered by",
  ordering_allowed: "Bill revoked, ordering allowed again!",
  orders: "Orders",
  orders_tab: "Order list",
  organizer: "Organizer: {0}",
  original_quantity: "Original quantity",
  other: "Other",
  outgoing_stock: "Stock movements",
  output_stores: "Output warehouses",
  package: "package",
  package_charge: "Package charge",
  paid: "Paid",
  paid_by: "Paid by",
  paid_order_cannot_be_deleted: "Paid orders cannot be deleted!",
  parent_category: "Parent category",
  pay: "Pay",
  pay_himself: "Pays himself",
  payer: "Payer",
  paying: "Paying",
  payment: "Payment",
  payment_due_in: "Payment due in {0} day(s)!",
  payment_method: "Payment method",
  payment_methods: "Payment methods",
  payment_received_by: "Payment received by",
  payment_successful: "Payment successful",
  payment_was_due_in: "Payment overdue since {0} day(s)!",
  payments: "Payments",
  paynance: {
    error: {
      "Transaction aborted": "Transaction aborted",
      "Transaction canceled by user": "Transaction manually cancelled by user",
      "Transaction timed out": "Transaction cancelled due to timeout"
    }
  },
  pays: "Pays",
  peanuts: "peanuts",
  pending: "Pending",
  per_item: "Per item",
  percent_name: "Percent",
  person: "Person",
  person_count: "Person count",
  persons: "Persons",
  phone_order_fee: "System usage fee for phone orders",
  phonenumber: "Phone",
  pickup: "Pickup",
  pickupyourorder: "Your order is ready",
  picture: "Picture",
  planned_closing_time: "Planned closing time",
  "Please pick a tip to proceed to payment!": "Please pick a tip to proceed to payment!",
  please_choose_mate_wanting_to_pay: "Who would like to pay?",
  please_choose_mate_who_paid: "Who paid?",
  please_click_on_a_time_slot_first: "First select the start of the booking (click on a time slot)!",
  please_select_a_restaurant: "Please select a restaurant",
  point_of_sale: "POS",
  pointin: "Point redemption",
  pointout: "Point accumulation",
  pos_producing_rules: "State after printing for point of sale",
  postcode: "Postal code",
  postcode_pattern: "^\\d\\d\\d\\d$",
  preorder_possible: "Preorder",
  price: "Price",
  price_estimation: "Proposed price",
  price_goal: "Target price",
  pricePerCostRatio: "Unitprice / cost ratio",
  print: "Print",
  print_invoice: "Print invoice",
  print_qrcode: "Print QR Code",
  print_receipt: "Print receipt",
  printer: "Printer",
  printer_actions: "Printing actions",
  printer_errors: {
    "cover-open": "Cover open",
    error: "Connection error",
    "out-of-paper": "Out of paper"
  },
  printer_server: "Printer server",
  printer_server_name: "Printer server name",
  printers: "Printers",
  network_speeds: "Network speeds",
  client: "Client",
  client_server: "Client/server",
  sse: "SSE",
  download: "Download",
  upload: "Upload",
  ip_address: "IP",
  printInvoice: "Print invoice",
  printTableSlip: "Print table QR code",
  printVATInvoice: "Print VAT invoice",
  privacy_policy: "Privacy policy",
  privacy_policy_link: "https://eatwithme.online/privacy-policy/",
  producing_rules: "State after printing",
  product: "Product",
  product_modified_save_it: "Modified product!",
  product_receipe_modified_recalculate_it: "Receipe changed. Would you like to recalculate the inventory for the past",
  product_search: "Product search",
  product_serving: "Type",
  productAnalitics: "Product analitics",
  production_line: "Production line",
  production_line_editor: "Production line",
  production_line_is_active: "Production line is active",
  production_line_length: "Queue",
  production_line_name: "Name",
  production_line_title: "{0} production line",
  production_line_waiting: "Dependent production line",
  production_lines: "Production lines",
  profit_margin: "Profit margin",
  profitandloss: {
    avgActualPrice: "Average price",
    avgCost: "Average cost",
    avgDiscount: "Average discount",
    avgPrice: "Average list price",
    closing_stock: "Closing stock",
    consumption: "Sold quantity",
    cost: "Cost",
    count: "Sale count",
    income: "Income",
    maxCost: "Max cost",
    maxPrice: "Max price",
    minCost: "Min cost",
    minPrice: "Min price",
    open_stock: "Open stock",
    profit: "Profit",
    profitp: "Profit (%)",
    purchase: "Purchase",
    scrapping: "Scrapping",
    shortage: "Surplus/shortage",
    stock_change: "Stock change"
  },
  proportional_addition_tooltip: "Proportional addition. The actual addition will be the product of the selected quantity of the base item and the quantity of the addition.",
  provide_address: "Please provide your address",
  provide_city: "Please provide your city",
  provide_company: "Please provide the name of your restaurant and/or company name",
  provide_country: "Please provide your country",
  provide_phonenumber: "Please provide your phone number",
  purchase_price: "Net purchase price",
  qr_code: "QR code",
  quantity: "Quantity",
  quantity_must_be_unique: "The available quantities must be unique!",
  quantity_type: "Quantity type",
  quantity_types: "Serving types",
  rateus: "Send us your feedback!",
  rbac: "Access roles",
  ready_for_delivery: "Serve it",
  rearrange_fields: "Rearrange fields",
  reauthenticate: "Reauthenticate",
  reboot_printerserver: "Reboot the local printer server",
  recalculateConsumption: "Recalculate stock",
  recalculateConsumptionAll: "Recalculate all stock",
  receipe: "Receipe",
  menuitem_tab_details: "Name and description",
  menuitem_tab_general_settings: "General settings",
  menuitem_tab_price_and_quantities: "Price and quantities",
  menuitem_tab_receipe_and_options: "Receipe and options",
  menuitem_tab_links: "Links",
  menuitem_tab_preview: "Preview",
  switch_off_preview: "Switch off preview",
  switch_on_preview: "Switch on preview",
  live_refresh: "Live refresh",
  preview_mode: "Preview mode",
  preview_mode_on_demand: "On demand",
  preview_mode_live: "Live",
  refresh_preview: "Refresh",
  receipt: "Receipt",
  receiptNumber: "Receipt number",
  receipts: "Receipts",
  references: "References",
  refillStock: "Target quantity to which we typically restock",
  refresh: "Refresh",
  refresh_my_data: "Update my details",
  refresh_position: "Refresh",
  rejection_reason: "Reason of rejection",
  reload_console: "Reload console",
  refresh_kiosks: "Refresh kiosks",
  repay_invoice_dialog: "Would you like to modify the payment details?",
  replace: "Replace",
  reprint: "Print",
  reprint_receipt: "Do you really want to reprint the receipt?",
  resend: "Try again",
  reset_to_defaults: "Reset to default",
  resource: {
    administration: {
      advertisements: {
        description: "Advertisement management",
        name: "Advertisements"
      },
      bankterminals: {
        description: "Bank card terminal management",
        name: "Bank card terminals"
      },
      cashregisters: {
        description: "Cash register management",
        name: "Cash registers"
      },
      description: "System administration",
      discounts: {
        description: "Discount management",
        name: "Discounts"
      },
      falatozz: {
        description: "Falatozz integration",
        name: "Falatozz"
      },
      foodpanda: {
        description: "Foodpanda integration",
        name: "Foodpanda"
      },
      labels: {
        description: "Label management",
        name: "Labels"
      },
      name: "Administration",
      printers: {
        description: "Printer management",
        name: "Printers"
      },
      productionlines: {
        description: "Production line management",
        name: "Production lines"
      },
      products: {
        description: "Product management",
        fullaccess: {
          description: "Full access to product administration",
          name: "Full access"
        },
        limitedaccess: {
          description: "Limited product access",
          name: "Limited access"
        },
        name: "Products"
      },
      rbac: {
        description: "Role-based access control",
        name: "Access roles"
      },
      restaurants: {
        description: "Restaurant settings",
        name: "Restaurants"
      },
      scales: {
        description: "Scale management",
        name: "Scales"
      },
      servings: {
        description: "Serving management",
        name: "Servings"
      },
      tables: {
        description: "Table management",
        name: "Tables"
      },
      vatcategories: {
        description: "VAT category management",
        name: "VAT categories"
      },
      wolt: {
        description: "Wolt integration",
        name: "Wolt"
      }
    },
    bar: {
      description: "Bar management",
      name: "Bar"
    },
    courierapp: {
      description: "Courier application access",
      name: "Courier application",
      registerpayment: {
        description: "Payment registration in courier application",
        name: "Payment registration"
      },
      selfassign: {
        description: "Self-assignment of orders to courier",
        name: "Self-assignment"
      },
      view: {
        name: "Open"
      }
    },
    guestscreen: {
      description: "Guest display management",
      name: "Guest display"
    },
    kiosk: {
      description: "Kiosk system",
      name: "Kiosk"
    },
    kitchen: {
      description: "Kitchen display system (KDS)",
      name: "KDS"
    },
    newsletter: {
      description: "Newsletter management",
      name: "Newsletter"
    },
    ntak: {
      description: "NTAK system",
      name: "NTAK"
    },
    reports: {
      bi: {
        customers: {
          description: "Customer analytics",
          name: "Customer analytics"
        },
        delivery: {
          description: "Delivery analytics",
          name: "Delivery analytics"
        },
        description: "Business Intelligence reports",
        financial: {
          description: "Revenue analytics",
          name: "Revenue"
        },
        financial_day: {
          description: "Daily revenue analytics",
          name: "Daily revenue"
        },
        name: "BI Reports",
        profit: {
          description: "Profit analytics",
          name: "Profit analytics"
        },
        rating: {
          description: "Rating analytics",
          name: "Rating analytics"
        }
      },
      dailyclosing: {
        description: "Daily closing reports",
        name: "Daily closing"
      },
      description: "Reports and analytics",
      menuitems: {
        description: "Product reports",
        name: "Products"
      },
      name: "Reports",
      prebookedorders: {
        description: "Pre-booked order reports",
        name: "Pre-booked orders"
      },
      tableoccupations: {
        description: "Table occupations and orders",
        name: "Orders",
        revert: {
          description: "Reopening/Cancellation of closed orders",
          name: "Reopen"
        },
        view: {
          name: "Open"
        }
      },
      todaytraffic: {
        description: "Daily traffic data",
        name: "Today's traffic"
      },
      traffic: {
        description: "Traffic reports",
        name: "Traffic"
      }
    },
    sales: {
      always_allow_delete: {
        description: "Always allow order deletion",
        name: "Order deletion"
      },
      dailyreport: {
        description: "Daily closing report access",
        fullreport: {
          description: "Full daily closing report",
          name: "Full report"
        },
        limited: {
          description: "Limited daily closing report",
          name: "Limited"
        },
        name: "Daily closing report"
      },
      homedelivery: {
        assigntocourier: {
          description: "Assign home delivery orders to courier",
          name: "Assign to courier"
        },
        closeorders: {
          description: "Close home delivery orders",
          name: "Close orders"
        },
        name: "Home delivery"
      },
      name: "Sales",
      pickup: {
        closeorders: {
          description: "Close pickup orders",
          name: "Close orders"
        },
        description: "Pickup order management",
        name: "Pickup"
      },
      pointofsale: {
        name: "Point of sale",
        view: {
          name: "View"
        }
      },
      printinvoice: {
        description: "Invoice printing permission",
        name: "Invoice printing"
      },
      registerpayment: {
        description: "Payment registration permission",
        name: "Payment registration"
      },
      revert: {
        description: "Cancellation of paid/closed orders",
        name: "Cancellation"
      },
      settings: {
        description: "Sales settings management",
        name: "Sales settings"
      },
      tablesoverview: {
        description: "Table overview",
        modify: {
          name: "Modify table layout"
        },
        name: "Table layout",
        view: {
          name: "View"
        }
      }
    },
    serving: {
      description: "Serving area",
      name: "Serving"
    },
    stockmanagement: {
      barcodes: {
        add: {
          name: "Add"
        },
        delete: {
          name: "Delete"
        },
        description: "Barcode management",
        modify: {
          name: "Modify"
        },
        name: "Barcode management",
        view: {
          name: "View"
        }
      },
      description: "Inventory management system",
      incomingstocks: {
        add: {
          name: "Add"
        },
        delete: {
          name: "Delete"
        },
        description: "Incoming stock management",
        modify: {
          name: "Modify"
        },
        name: "Incoming stocks",
        view: {
          name: "View"
        }
      },
      inventories: {
        add: {
          name: "Add"
        },
        delete: {
          name: "Delete"
        },
        description: "Inventory management",
        modify: {
          name: "Modify"
        },
        name: "Inventories",
        view: {
          name: "View"
        }
      },
      inventorytemplates: {
        add: {
          name: "Add"
        },
        delete: {
          name: "Delete"
        },
        description: "Inventory template management",
        modify: {
          name: "Modify"
        },
        name: "Inventory templates",
        view: {
          name: "View"
        }
      },
      inventoryscrapping: {
        add: {
          name: "Add"
        },
        delete: {
          name: "Delete"
        },
        description: "Inventory scrapping management",
        modify: {
          name: "Modify"
        },
        name: "Inventory scrapping",
        view: {
          name: "View"
        }
      },
      name: "Inventory management",
      pandl: {
        description: "Profit and loss analytics",
        name: "Profit and loss analytics"
      },
      shoppinglist: {
        description: "Shopping list management",
        name: "Shopping list"
      },
      stocklist: {
        description: "Stock list management",
        name: "Stock list"
      },
      stockmovements: {
        add: {
          name: "Add"
        },
        delete: {
          name: "Delete"
        },
        description: "Stock movement management",
        modify: {
          name: "Modify"
        },
        name: "Stock movements",
        view: {
          name: "View"
        }
      },
      stockstatistics: {
        description: "Stock statistical reports",
        name: "Stock statistics"
      },
      stores: {
        add: {
          name: "Add"
        },
        delete: {
          name: "Delete"
        },
        description: "Warehouse management",
        modify: {
          name: "Modify"
        },
        name: "Warehouses",
        view: {
          name: "View"
        }
      },
      suppliers: {
        add: {
          name: "Add"
        },
        delete: {
          name: "Delete"
        },
        description: "Supplier management",
        modify: {
          name: "Modify"
        },
        name: "Suppliers",
        view: {
          name: "View"
        }
      }
    },
    tablebooking: {
      book: {
        name: "New booking"
      },
      description: "Table booking system",
      name: "Table booking",
      settings: {
        name: "Settings"
      },
      "view:": {
        name: "Open"
      }
    },
    waiter: {
      description: "Waiter screen access",
      name: "Waiter screen"
    }
  },
  restart_needed: "(Re)start the printer",
  restart_printer: "Please restart the following printer: {0}",
  restart_printerserver: "Reconnecting the printers",
  restaurant: "Restaurant",
  restaurant_editor: "Restaurant",
  restaurant_properties_includedoptions: "Recipe - default included ingredients",
  restaurant_properties_mandatoryoptions: "Recipe - mandatory ingredients",
  restaurant_properties_optionaloptions: "Recipe - optional options",
  restaurant_settings: {
    default_language: "Default language"
  },
  revert: "Let's revert",
  revert_payment: "Do you really want to revert the payment?",
  revert_table_mate_payment: "Reopen and revert payment",
  revert_table_occupation: "Do you really want to revert?",
  revert_table_occupation2: "What do you want to do with this order?",
  revert_table_occupation_multi_payment: "Do you really want to revert? There were multiple payers, the payment can be reverted on the payments tab!",
  role: "Role",
  role_names: {
    admin: "Administrator",
    cook: "Cook",
    courier: "Courier",
    finance: "Finance",
    printerserver: "PrinterServer",
    store: "Inventory manager",
    tester: "Tester",
    waiter: "Waiter"
  },
  roles: "Roles",
  room: "Room",
  room_editor: "Room",
  room_tables: "{0} tables",
  room_tables_seats: "{0} tables with {1} seats",
  rotate_left: "Rotate left (45°)",
  rotate_right: "Rotate right (45°)",
  rounding: "Rounding",
  sale: "Sale",
  save: "Save",
  save_and_close: "Save & Close",
  save_and_new: "Save+Copy",
  save_and_open: "Save & Test",
  save_and_unlock: "Pay and free up",
  save_layout: "Save table layout",
  save_my_details_for_later_use: "I consent that my personal data to be stored and managed by {0} and the cloud based retaurant management system EatWithMe.",
  save_update_address: "Save and update address",
  saved_my_details_for_later_use: "I agreed that my personal data to be stored and managed by {0} and the cloud based retaurant management system EatWithMe.",
  scan_to_join_table: "!LF!ESC|cA!ESC|4CTable {0}!LF!LF!ESC|4C!ESC|cAScan and order!LF!ESC|cAand manage your consumption online!",
  scan_to_pay_table: "Scan with your phone\r\n to see the consumption at the table nr. {0}.\r\nand to online settle the bill!",
  scanit: "Is this your bill? Scan it!",
  scope: "Scope",
  scrapping: "Scrapping",
  search_pattern: "Search pattern",
  seat: "Seat",
  seat_types: {
    normal_chair: "Normal chair",
    wooden_chair: "Wooden chair"
  },
  seats: "seats",
  secret_key: "Secret key",
  select_a_category: "select a category",
  select_a_product: "select a product",
  select_a_quantity_type: "select a quantity type",
  select_a_store: "select a warehouse",
  select_a_supplier: "select a supplier",
  select_a_vat_category: "select a VAT category",
  select_store: "Select warehouse",
  selling_price: "Gross selling prince",
  seqnr: "Sequence number",
  server_url: "WAN url",
  service: "Service",
  service_fee: "Service fee",
  service_fee_net: "Service fee net",
  service_fee_vat: "Separated service fees",
  serving: "Serving",
  serving_type: "Kiszerelés",
  sesame: "sesame",
  settings: "Settings",
  shareable: "Shareable",
  short_name: "Short name",
  shortage: "Shortage",
  show_deleted: "Show deleted items",
  sitting_at_table: "Sitting at table no. {0}",
  skin_picker: "Theme picker",
  skins: [{ "id": "default", "name": "Default" }, { "id": "fancy", "name": "Fancy" }, { "id": "flat", "name": "Flat" }, { "id": "night", "name": "Night" }, { "id": "old", "name": "Old style" }],
  something_strange_happened_resync: "Something unexpected happened! Resynchronizing...",
  sort_abc: "Sort",
  source_and_target_store_should_be_different: "Source and target warehouse should be different",
  soybeans: "soybeans",
  split_invoice: "Split invoice",
  stable_versions: "Stable versions",
  start_count: "Expected",
  status: "Status",
  stock: "Stock",
  stock_movement: "Stock movemement",
  stockAnalitics: "Stock analitics",
  store: "Warehouse",
  stores: "warehouses",
  storno: "Storno",
  stornoreason: "Cancellation reason",
  stornoreason_0: "Other",
  stornoreason_1: "Customer cancellation",
  stornoreason_2: "Incorrect input",
  stornoreason_3: "Incorrect payment method input",
  stornoreason_4: "Product out of stock",
  stornoreason_5: "Incorrect document type issuance",
  stornoreason_6: "Failed payment method usage",
  stornoreason_7: "Incorrect customer data/incorrect input",
  stornoreason_8: "Test purchase",
  submit_and_accept_and_print_and_pay_new_orders: "Payment",
  submit_and_accept_and_print_new_orders: "Print new orders",
  submit_and_accept_new_orders: "Submit and accept new orders",
  submit_new_orders: "Submit new orders",
  subscription: "Subscription",
  sulfites: "sulfites",
  supplier: "Supplier",
  supplier_code: "Supplier code",
  suppliers: "Suppliers",
  surplus: "Surplus",
  suspend_ordering: "Suspend ordering",
  syncronize_barcodes: "Synchronize",
  table: "Table",
  table_editor: "Table",
  table_extentions_placeholder: "+table_number=total_seats_count e.g. +4=8,+4+5=12",
  table_free_seats: "Free seats available",
  table_is_active: "Table is active",
  table_is_shareable: "Table is shareable",
  table_number: "Table number: {0}",
  table_number_label: "Table number",
  table_occupation_number: "Occupation nr. {0}",
  table_occupations: "Tables",
  table_ready_for_delivery: "!ESC|bC!ESC|4CTable no. {0}!LF!ESC|bC!ESC|4COrder no. {1}!LF!ESC|bC!ESC|4C{2}!LF!ESC|bC!ESC|4CServe it!",
  table_types: {
    circle_four_seats: "Four seats round table",
    person: "Person",
    persons: "Persons",
    pool_table: "Pool table",
    rectangle_four_seats: "Four seats table",
    rectangle_six_seats: "Six seats table",
    rectangle_two_seats: "Two seats table",
    rounded_four_seats: "Four seats rounded table",
    rounded_six_seats: "Six seats rounded table"
  },
  tableOccupations: "Table occupations",
  tables: "Tables",
  tablesoverview: {
    tooltip: {
      printed: "Successfully printed.",
      printfailed: "Unsuccessful printing attempt. Please print again.",
      printing: "Printing in progress",
      unprinted: "The order has not been printed yet."
    }
  },
  takeaway: "Takeaway",
  takeaway_addition_tooltip: "Applied for takeaway or home delivery",
  takeaway_consumption: "Takeaway consumption",
  takeawayConsumption: "Takeaway consumption",
  tare_weight: "Tare weight",
  target_table_same_and_source: "Target table is the same as the source!",
  tax_number: "Tax number",
  tax_number_pattern: "(^$)|(^\\d\\d\\d\\d\\d\\d\\d\\d-\\d-\\d\\d$)",
  team_number: "Team: {0}",
  terminal: "Terminal",
  test: "Test",
  test_mode: "Test mode",
  test_scale: "Scale test",
  test_system: "Test system",
  test_versions: "Test versions",
  teya: {
    error: {
      CANCELLED: "Card payment cancelled",
      CANCELLING: "Cancelling card payment in progress",
      FAILED: "Card payment failed",
      NEW: "Card payment failed. No response from terminal!",
      unknown: "Card payment failed"
    }
  },
  thanks_for_buying: "Thanks for buying",
  "The address.address field is required.": "The address field is required.",
  "The address.address must be at least 2 characters.": "The address must be at least 2 characters.",
  "The address.city field is required.": "The city field is required.",
  "The address.city must be at least 2 characters.": "The city name must be at least 2 characters.",
  "The address.post code field is required.": "The postal code field is required.",
  "The device communications channel could not be opened, check the device and retry.": "A nyomtató nincs bekapcsolva vagy rosszul van bekonfigurálva.",
  "The name field is required.": "The name field is required.",
  the_table_is_not_occupied: "This table is free!",
  there_already_exists_a_table_with_this_number: "You already placed a table with this number!",
  layout_must_remain_wider_than_tall: "Layout must remain wider than tall.",
  there_is_a_loop_in_the_additions: "There is a reference loop between the menu items!",
  this_month: "This month",
  this_quarter: "This quarter",
  this_week: "This week",
  time: "Time",
  timetable: "Opening hours",
  timing: "Timing",
  timing_appetizer: "Appetizer",
  timing_asap: "As soon as possible",
  timing_desert: "Dessert",
  timing_inherit: "Inherit",
  timing_last: "At the end",
  timing_maincourse: "Main course",
  timing_null: "",
  tip: "Tip",
  tip_amount_seems_excesive: "Amount seems excesive! Continue?",
  to_store: "Target warehouse",
  to_whom: "To whom",
  toDate: "To date",
  today: "Today",
  token: "Token",
  tomorrow: "Tomorrow",
  too_many_bluetooth_cashiers: "Only one bluetooth cachier can be paired simultaneously!",
  tooltip: {
    address: "Please provide the full address, e.g., 'Árpád köz 2.'. If the system cannot find the address, the system accepts any address with a '/' at the beginning, e.g., '/At the entrance of the train station'",
    comment: "Set a comment for this order only!",
    couriers: "Possible couriers (users with courier privileges). This permission can be granted to registered users in the administration.",
    delivery_time: "Planned delivery time",
    header_accepted_order: "Order confirmed! You can reconfirm all pending or selected orders by double-clicking!",
    header_filter_accepted_order: "Filter confirmed orders",
    header_filter_new_incoming_order: "Filter new orders",
    header_filter_order_assigned: "Orders assigned to courier",
    header_filter_order_delivered: "Filter orders delivered",
    header_filter_order_in_production: "Filter order under preparation",
    header_filter_order_ready: "Filters ready orders",
    header_filter_order_under_delivering: "Filter orders under delivery",
    header_new_incoming_order: "New order awaiting confirmation!",
    header_order_delivered: "Order delivered! You can set this status for all orders or selected ones by double-clicking!",
    header_order_in_production: "Order under preparation! You can set this status for all orders or selected ones by double-clicking!",
    header_order_ready: "Order ready! You can set this status for all orders or selected ones by double-clicking!",
    header_order_under_delivering: "Order under delivery! You can set this status for all orders or selected ones by double-clicking!",
    header_print_invoice: "Double-click to print the invoices for all or selected orders!",
    header_print_receipt: "Double-click to print all yet unprinted orders or selected orders!",
    print_all_labels: "Double-click to print all labels!",
    header_unlock: "Double-click to unlock or lock all unlockable (delivered and paid) orders!",
    link_courier: "Double-click to assign the selected orders to this courier!",
    paid: "Invoice paid.",
    pickup_time: "Planned pickup time",
    print_invoice: "Double-click to print the invoice!",
    print_receipt: "Double-click to print the order!",
    printed: "Successful printing! Double-click to print a copy.",
    printfailed: "Unsuccessful printing attempt. Double-click to make a new printing attempt.",
    printing: "Printing in progress",
    qrcode: "Double-click to print the courier's block.",
    register_payment: "Double-click to register payment details.",
    reprint_receipt: "Double-click to print the order again!",
    set_accepted_order: "Order confirmed! You can confirm the order again by double-clicking!",
    set_new_incoming_order: "New order awaiting confirmation!",
    set_order_delivered: "Order delivered! You can set this status by double-clicking!",
    set_order_in_production: "Order under preparation! You can set this status by double-clicking!",
    set_order_ready: "Order ready! You can set this status by double-clicking!",
    set_order_under_delivering: "Order under delivery! You can set this status by double-clicking!",
    unlink_courier: "Double-click to remove the order from the courier!",
    unlock: "Double-click to unlock or lock the order!",
    unprinted: "The order has not been printed yet. Double-click to print.",
    user_comment: "Set a permanent comment for your customer. This comment will show up for next orders as well!"
  },
  tooltip_label_count: "Number of label to be printed for this product in case label printer is in use",
  tooltip_notprinted: "Not printed yet!",
  tooltip_partprinted: "Printing error! New printing attempt in progress!",
  tooltip_printed: "Printed",
  tooltip_printfailed: "Printing error!",
  tooltip_printing: "Printing in progress!",
  top_category: "Top category",
  total: "Total",
  total_incoming_stock_entries: "<span>{0}</span> <span class='browser-only'> entries in total</span>",
  total_stock_cost: "Stock purchase value",
  total_stock_value: "Stock sale value",
  total_value_difference: "Total value difference",
  town: "Town",
  traffic: "Traffic",
  type: "Type",
  typical_rejection_reasons: "Typical reasons",
  ui: {
    addResource: "Add Resource",
    addRole: "Add Role",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    deleteResources: "Delete Resources",
    description: "Description",
    descriptionLabel: "Description:",
    newResource: "New Resource",
    permission: "Permission",
    permissionName: "Permission name:",
    resource: "Resource",
    resourceName: "Resource Name:",
    role: "Role",
    roleName: "Role Name:",
    save: "Save"
  },
  unassigned_orders: "Unassigned orders",
  uncategorized_items: "Products without a category set",
  unit_of_consumption: "Selling/Usage unit",
  unit_price: "Unit price",
  unit_price_estimation: "Proposed unit price",
  unknown_person_pays: "Person {0}. pays",
  unlock: "Free it up",
  unoccupy: "Free up",
  until_when_delete_the_traffic: "Until when do you want to delete past traffic (format: YYYY-MM-DD)",
  updateBookingNotSuccessful: "Saving customer data was not successful",
  upload: "Upload",
  upload_barcodes: "Upload",
  upload_successful: "Upload successful",
  user: "User",
  user_comment: "Other guest information",
  user_missing: "No user is registered for the provided email address",
  users: "Users",
  value_difference: "Value difference",
  vat: "VAT",
  vat_categories: "VAT categories",
  vat_category: "VAT category",
  vat_category_editor: "VAT category",
  vat_category_name: "VAT category name",
  vat_invoice: "VAT invoice",
  view: "View",
  visible_online: "Visible to guests",
  "voipphone-Registration failed:Authentication Error": "Registration failed:Authentication Error",
  "voipphone-undefined": "Offline",
  waiterOrder: "Waiter order",
  webshop: "Webshop",
  webshop_order_fee: "System usage fee for webshop orders",
  webshopOrder: "Webshop order",
  week: "Week",
  when: "When",
  withdraw: "Withdraw",
  without_allergen: "Can be prepared without {0} allergen",
  wolt: {
    delete_category: "Delete product category from Wolt",
    delete_category_items: "Delete from Wolt products with exists only there for this category",
    delete_menu_item: "Delete product from Wolt",
    delete_menu_items: "Delete products from Wolt",
    delete_selected_elements: "Delete selected products from Wolt",
    elements_in_sync: "Number of products in sync",
    elements_in_to_delete: "Number of extra products on Wolt",
    elements_in_to_upload: "Number of products missing from Wolt",
    elements_in_unsync: "Number of products out of sync",
    reload: "Refresh from Wolt",
    resync_selected_elements: "Resynchronized selected products to Wolt",
    sync_category_items: "Resynchronize the products which already exists both in EatWithMe and Wolt",
    sync_menu_item: "Synchronize product to Wolt",
    upload_category: "Delete product category from Wolt",
    upload_category_items: "Upload products missing from Wolt",
    upload_menu_item: "Upload product to Wolt",
    upload_selected_elements: "Upload selected products to Wolt"
  },
  yearsAgo: "{0} years ago",
  yes: "Yes",
  yesterday: "Yesterday",
  "You do not have subscription for this operation": "You do not have subscription for this operation",
  you_are_not_authorized_to_access_this_feature: "Based on your subscription you are not allowed to access this feature.",
  you_are_not_authorized_to_access_this_restaurant_with_an_app: "Based on your subscription you are not allowed to access this unit.",
  you_cannot_order_so_many: "You cannot order <strong>{0}</strong> pieces at on time!",
  you_need_admin_right_for_this_action: "You need administrator privileges to perform this action!",
  CLEAR_PRODUCT: 'Clear product',
  ADD_MISSING_PRODUCT: 'Add missing product',
  CLEAR_QUANTITY_TYPE: 'Clear quantity type',
  CLEAR_VAT_CATEGORY: 'Clear VAT category',
  CLEAR_STORE: 'Clear store',
  VALIDATION_SUCCESS: 'All validations successful',
  SEARCH_PRODUCTS: 'Type to search products...',
  SEARCH_QUANTITY_TYPES: 'Type to search quantity types...',
  SEARCH_VAT_CATEGORIES: 'Type to search VAT categories...',
  SEARCH_STORES: 'Type to search stores...',
  enter_invoice_id: 'Please enter the invoice number',
  enter_delivery_note_id: 'Please enter the delivery note id',
  cannotSave: 'Saving is not possible due to errors',
  select_vat_category: 'Select a VAT category',
  query_invoice_data: 'Query invoice data from the NAV ONLINE-SZAMLA system',
  failed_to_query_invoice_data: 'Failed to query invoice data from the NAV ONLINE-SZAMLA system',
  open_in_new_tab: 'Open in new tab',
  upload_menu: 'Upload menu',
  connect_choiceqr: "Connect to ChoiceQR",
  choiceqr_connect_token_info: "In the ChoiceQR window you will have to use the following token (code) to authorize the connection. Copy it first, then open the ChoiceQR page.",
  choiceqr_copy: "Copy to clipboard",
  choiceqr_copied: "Copied",
  choiceqr_open_connect: "Open ChoiceQR",
  choiceqr_connected: "ChoiceQR is now connected.",
  choiceqr_waiting: "Waiting for the connection to complete...",
  choiceqr_missing_domain_or_client: "Please fill in the domain and clientId in the settings first.",
  connect_wolt_instance: "Connect Wolt Account",
  connect_button: "Connect to Wolt",
  code_received: "Authorization code received!",
  error: "Error: {0}",
  sync_superset: "Superset synchronization",  
  invalid_barcode_gross_tare_weight: "Gross weight must be greater than tare weight!",
  storno_payment_method: "Refund payment method",
  refund_payment_method: "Refund payment method",
  card: "Card",
  cash: "Cash",
  cash_return_calculation: "Change calculation",
  cash_return_calculation_help: "When enabled, cash denominations are visible only when a cash payment amount is greater than 0 and the cash input has focus. Click denominations to set the received cash amount. The system calculates the change from these values.",
  storno_quantity: "Storno quantity",
  return_and_refund: "Return and refund",
  refundreason_1: "Defective product",
  refundreason_2: "Customer withdrawal from purchase",
  refundreason_3: "Other reason",
  amount_with_tip: "Amount with tip",
  VATInvoice: "VAT Invoice",
  preorder: "Pre-order",
  automation: {
    id: "ID",
    name: "Name",
    menu_item: "Menu item",
    menu_category: "Menu category",
    optional_category_options: "Optional category options",
    optionType: "Option type",
    proportional: "Proportional",
    context: "Context"
  },
  drive: {
    check_for_wolt_delivery: "Check for Wolt delivery",
    wolt_drive_delivery_time: "Scheduled Wolt delivery time",
    wolt_drive_price: "Wolt delivery price",
    wolt_drive_no_info: "No information about Wolt delivery conditions",
    wolt_drive_reason: "Wolt delivery conditions are not met because",
    "Dropoff location is outside the delivery area": "Dropoff location is outside the delivery area",
    "Dropoff location is outside of the delivery area": "Dropoff location is outside of the delivery area",
    delivery_with_wolt_courier: "Delivery with Wolt courier",
    wolt_courier: "Wolt courier",
    "Request made outside delivery hours": "Request made outside delivery hours",
    "Delivery area is closed": "Delivery area is closed",
    "Delivery area will be closed at the requested delivery time": "Delivery area will be closed at the requested delivery time",
    "already_received_cannot_reassign": "The order has already been confirmed by the Wolt courier, it cannot be reassigned to a new courier",
    "already_received_cannot_delete": "The order has already been confirmed by the Wolt courier, the courier order cannot be deleted",
    "Value error, Invalid phone number: (1) The string supplied did not seem to be a phone number": "Value error, invalid phone number: The provided string did not seem to be a phone number",
    "Value error, 'name' can not be empty": "Value error, 'name' cannot be empty",
    "Order is not in a rejectable state. Please contact support to cancel it": "Order is not in a rejectable state. Please contact support to cancel it",
    already_assigned_to_wolt_courier: "You have already assigned a Wolt courier to this order",
    earliest_delivery_time: "Earliest delivery time is %{time} instead of %{originaltime} %{fromNow}",
  },
  contact_email: "Contact email",
  website_url: "Website URL",
  login_in_progress: "Login in progress...",
  deleted_by: "Deleted by",
  not_bound_to_table: "Not bound to a table",
  no_epd: "No table display selected",
  pairing_code: "Pairing code",
  pair: "Pair",
  new_purchase_price: "New purchase price.",
  last_approved_purchase_price: "Last approved purchase price.",
  approve_it_with_double_click: "Approve the new purchase price with a double click!",
  costChangeFilter: "Shows only items whose purchase price changed by the given percentage or more",
  stockDangerFilter: "Shows only items with stock at risk",
  stockBuyFilter: "Shows only items that require stock replenishment",
  filters: "Filters",
  approved_cost: "Approved purchase price",
  _approved_cost: "Approved purchase price",
  cost_change: "Change",
  _cost_change: "Change",
  new_average_cost: "New average purchase price",
  _new_average_cost: "New average purchase price",
  cost_change_warning: "Cost overrun",
  costChangeThreshold: "Cost change threshold",
  approve: "Approve",
  the_following_products_were_not_found: "The following products were not found in the system",
  promotional_price: "Promotional price",
  enter_promotional_price: "Promotional price",
  enter_promotion_name: "Promotion name",
  enter_promotional_start_date: "Enter promotion start date",
  enter_promotional_end_date: "Enter promotion end date",
  promotion_name: "Promotion name",
  promotional_start_date: "Promotion start",
  promotional_end_date: "Promotion end",
  promotion_price: "Promotional price",
  promotion: "Promotion",
  promotions: "Promotions",
  differences_in_promotionName: "Differences in promotion name",
  differences_in_promotionPrice: "Differences in promotional price",
  differences_in_promotionStart: "Differences in promotion start date",
  differences_in_promotionEnd: "Differences in promotion end date",
  old: "Old",
  permanent_delete: "Permanent delete",
  menu_item_availability: "Menu Item Availability",
  availability_explanation: "Items marked as unavailable are automatically hidden on all ordering platforms (kiosk, Wolt, Foodpanda, etc.).",
  unavailable_items: "Currently unavailable",
  all_items_available: "All items available",
  make_unavailable_matching: "Disable matching",
  make_available_matching: "Enable matching",
  make_all_available: "Enable all",
  search_to_add_remove: "Search...",
  availability_enabled_hint: "The item is available again. It can appear again on Wolt/Foodora, kiosk, and webshop platforms.",
  availability_disabled_hint: "The item is now unavailable. It may be hidden on Wolt/Foodora, kiosk, and webshop platforms.",
  tabledisplay_link_button: "Link table display",
  tabledisplay_scan_unavailable: "QR scanner is not available on this device.",
  tabledisplay_scan_invalid: "Scanned QR code does not contain a valid display id.",
  tabledisplay_scan_failed: "Display QR scan failed.",
  tabledisplay_link_success: "Table display linked: {0} -> {1} (template: {2}).",
  tabledisplay_link_failed: "Failed to create and link ESL product for the scanned display.",
  unavailable: "unavailable",
  available: "available",
};
export default admin_local_en;
